const navigation = {
  'navigation.section.collect': 'Collect',
  'navigation.section.process': 'Process',
  'navigation.section.create': 'Create',
  'navigation.section.work': 'Work',
  'navigation.section.agents': 'Agents',
  'navigation.section.manage': 'Manage',
  'navigation.item.sources': 'Sources',
  'navigation.item.materials': 'Materials',
  'navigation.item.notebooks': 'Notebooks',
  'navigation.item.search': 'Ask and Search',
  'navigation.item.image_generator': 'Image Generator',
  'navigation.item.podcasts': 'Podcasts',
  'navigation.item.digital_employees': 'Mobile Employees',
  'navigation.item.browser_employees': 'Browser Employees',
  'navigation.item.pc_employees': 'PC Employees',
  'navigation.item.marketplace': 'App Store',
  'navigation.item.skills': 'Skills',
  'navigation.item.workflows': 'Workflows',
  'navigation.item.cron': 'Cron',
  'navigation.item.models': 'Models',
  'navigation.item.transformations': 'Transformations',
  'navigation.item.settings': 'Settings',
  'navigation.item.advanced': 'Advanced',
  'navigation.item.member_center': 'Member Center',
  'navigation.create': 'Create',
  'navigation.create.digital_employees': 'Mobile Employees',
  'navigation.create.source': 'Source',
  'navigation.create.notebook': 'Notebook',
  'navigation.create.image_generator': 'Image Generator',
  'navigation.create.podcast': 'Podcast',
  'navigation.create.tooltip': 'Create',
  'navigation.backToNotebook': 'Back to Notebook',
  'navigation.backToSources': 'Back to Sources',
}

const controls = {
  'controls.theme': 'Theme',
  'controls.quickActions': 'Quick actions',
  'controls.quickActionsHint': 'Navigation, search, ask, theme',
  'controls.signOut': 'Sign Out',
}

const user = {
  'user.menuTitle': 'User',
  'user.systemLabel': 'System',
  'user.systemTooltip': 'Tenant: {system}',
  'user.systemUnknown': 'Unknown system',
  'user.tenantUnknown': 'Unknown tenant',
  'user.spaceUnknown': 'Unknown space',
  'user.spaceLabel': 'Space',
  'user.switchTenant': 'Switch Tenant',
  'user.roleLabel': 'Role',
  'user.role.owner': 'Owner',
  'user.role.admin': 'Admin',
  'user.role.employee': 'Employee',
  'user.role.unknown': 'Unknown role',
}

const settingsLanguage = {
  'settings.title': 'Settings',
  'settings.language.title': 'Interface language',
  'settings.language.description': 'Choose the language for the dashboard',
  'settings.language.note': 'Changes apply immediately to navigation and UI controls.',
  'settings.language.en': 'English',
  'settings.language.zh': '中文',
}

const settingsActions = {
  'settings.actions.save': 'Save Settings',
  'settings.actions.saving': 'Saving...',
}

const settingsCommon = {
  'settings.common.helpMeChoose': 'Help me choose',
  'settings.load.errorTitle': 'Failed to load settings',
  'settings.load.errorUnexpected': 'An unexpected error occurred.',
  'common.all': 'All',
}

const settingsContentProcessing = {
  'settings.content.title': 'Content Processing',
  'settings.content.description': 'Configure how documents and URLs are processed',
  'settings.content.doc.label': 'Document Processing Engine',
  'settings.content.doc.placeholder': 'Select document processing engine',
  'settings.content.doc.option.auto': 'Auto (Recommended)',
  'settings.content.doc.option.docling': 'Docling',
  'settings.content.doc.option.simple': 'Simple',
  'settings.content.doc.help.docling':
    'Docling is a little slower but more accurate, especially if the documents contain tables and images.',
  'settings.content.doc.help.simple':
    "Simple will extract any content from the document without formatting it. It's ok for simple documents, but will lose quality in complex ones.",
  'settings.content.doc.help.auto':
    'Auto (recommended) will try to process through Docling and default to Simple.',
  'settings.content.url.label': 'URL Processing Engine',
  'settings.content.url.placeholder': 'Select URL processing engine',
  'settings.content.url.option.auto': 'Auto (Recommended)',
  'settings.content.url.option.firecrawl': 'Firecrawl',
  'settings.content.url.option.jina': 'Jina',
  'settings.content.url.option.simple': 'Simple',
  'settings.content.url.help.firecrawl':
    'Firecrawl is a paid service (with a free tier) and very powerful.',
  'settings.content.url.help.jina': 'Jina is a good option as well and also has a free tier.',
  'settings.content.url.help.simple':
    'Simple will use basic HTTP extraction and will miss content on JavaScript-based websites.',
  'settings.content.url.help.auto':
    'Auto (recommended) will try to use Firecrawl (if API Key is present). Then, it will use Jina until it reaches the limit (or will keep using Jina if you set up the API Key). It will fall back to Simple when none of the previous options is possible.',
}

const settingsEmbedding = {
  'settings.embedding.title': 'Embedding and Search',
  'settings.embedding.description': 'Configure search and embedding options',
  'settings.embedding.label': 'Default Embedding Option',
  'settings.embedding.placeholder': 'Select embedding option',
  'settings.embedding.option.ask': 'Ask',
  'settings.embedding.option.always': 'Always',
  'settings.embedding.option.never': 'Never',
  'settings.embedding.help.intro':
    "Embedding the content will make it easier to find by you and by your AI agents. If you are running a local embedding model (Ollama, for example), you shouldn't worry about cost and just embed everything. For online providers, you might want to be careful only if you process a lot of content (like 100s of documents at a day).",
  'settings.embedding.help.always':
    'Choose always if you are running a local embedding model or if your content volume is not that big.',
  'settings.embedding.help.ask': 'Choose ask if you want to decide every time.',
  'settings.embedding.help.never':
    "Choose never if you don't care about vector search or do not have an embedding provider.",
  'settings.embedding.help.cost':
    "As a reference, OpenAI's text-embedding-3-small costs about 0.02 for 1 million tokens -- which is about 30 times the Wikipedia page for Earth. With Gemini API, Text Embedding 004 is free with a rate limit of 1500 requests per minute.",
}

const settingsFiles = {
  'settings.files.title': 'File Management',
  'settings.files.description': 'Configure file handling and storage options',
  'settings.files.label': 'Auto Delete Files',
  'settings.files.placeholder': 'Select auto delete option',
  'settings.files.option.yes': 'Yes',
  'settings.files.option.no': 'No',
  'settings.files.help.intro':
    'Once your files are uploaded and processed, they are not required anymore. Most users should allow FishOwn Agent to delete uploaded files from the upload folder automatically. Choose no ONLY if you are using Notebook as the primary storage location for those files (which you should not be at all). This option will soon be deprecated in favor of always downloading the files.',
  'settings.files.help.yes':
    'Choose yes (recommended) to automatically delete uploaded files after processing.',
  'settings.files.help.no': 'Choose no only if you need to keep the original files in the upload folder.',
}

const notebooksPage = {
  'notebooks.page.title': 'Notebooks',
  'notebooks.page.searchPlaceholder': 'Search notebooks...',
  'notebooks.page.create': 'New Notebook',
  'notebooks.page.activeTitle': 'Active Notebooks',
  'notebooks.page.archivedTitle': 'Archived Notebooks',
  'notebooks.page.empty.searchActiveTitle': 'No notebooks match your search',
  'notebooks.page.empty.searchActiveDescription': 'Try using a different notebook name.',
  'notebooks.page.empty.searchArchivedTitle': 'No archived notebooks match your search',
  'notebooks.page.empty.searchArchivedDescription': 'Modify your search to find archived notebooks.',
}

const notebooksList = {
  'notebooks.list.empty.title': 'No notebooks yet',
  'notebooks.list.empty.description': 'Start by creating your first notebook to organize your research.',
}

const notebooksCard = {
  'notebooks.card.archived': 'Archived',
  'notebooks.card.unarchive': 'Unarchive',
  'notebooks.card.archive': 'Archive',
  'notebooks.card.delete': 'Delete',
  'notebooks.card.noDescription': 'No description',
  'notebooks.card.updated': 'Updated',
  'notebooks.card.confirm.title': 'Delete Notebook',
  'notebooks.card.confirm.description':
    'Are you sure you want to delete "{name}"? This action cannot be undone and will delete all sources, notes, and chat sessions.',
  'notebooks.card.confirm.cta': 'Delete',
}

const notebooksHeader = {
  'notebooks.header.namePlaceholder': 'Notebook name',
  'notebooks.header.archivedBadge': 'Archived',
  'notebooks.header.unarchive': 'Unarchive',
  'notebooks.header.archive': 'Archive',
  'notebooks.header.knowledgeGraph': 'Knowledge Graph',
  'notebooks.header.knowledgeGraphComingSoon': 'Not available yet. Stay tuned.',
  'notebooks.header.delete': 'Delete',
  'notebooks.header.descriptionPlaceholder': 'Add a description...',
  'notebooks.header.descriptionEmpty': 'Add a description...',
  'notebooks.header.meta.created': 'Created',
  'notebooks.header.meta.updated': 'Updated',
  'notebooks.header.confirm.title': 'Delete Notebook',
  'notebooks.header.confirm.description':
    'Are you sure you want to delete "{name}"? This action cannot be undone and will delete all sources, notes, and chat sessions.',
  'notebooks.header.confirm.cta': 'Delete Forever',
}

const notebooksDetail = {
  'notebooks.detail.notFoundTitle': 'Notebook Not Found',
  'notebooks.detail.notFoundDescription': 'The requested notebook could not be found.',
  'notebooks.detail.tabs.sources': 'Sources',
  'notebooks.detail.tabs.notes': 'Notes',
  'notebooks.detail.tabs.chat': 'Chat',
}

const notebooksKnowledgeGraph = {
  'notebooks.knowledgeGraph.title': 'Knowledge Graph',
  'notebooks.knowledgeGraph.description': 'Knowledge graph for notebook {notebookId}.',
}

const notebooksSources = {
  'notebooks.sources.collapsedLabel': 'Sources',
  'notebooks.sources.title': 'Sources',
  'notebooks.sources.add': 'Add Source',
  'notebooks.sources.addNew': 'Add New Source',
  'notebooks.sources.addExisting': 'Add Existing Source',
  'notebooks.sources.empty.title': 'No sources yet',
  'notebooks.sources.empty.description': 'Add your first source to start building your knowledge base.',
  'notebooks.sources.delete.title': 'Delete Source',
  'notebooks.sources.delete.description': 'Are you sure you want to delete this source? This action cannot be undone.',
  'notebooks.sources.delete.cta': 'Delete',
  'notebooks.sources.remove.title': 'Remove Source from Notebook',
  'notebooks.sources.remove.description': 'Are you sure you want to remove this source from the notebook? The source itself will not be deleted.',
  'notebooks.sources.remove.cta': 'Remove',
}

const notebooksNotes = {
  'notebooks.notes.collapsedLabel': 'Notes',
  'notebooks.notes.title': 'Notes',
  'notebooks.notes.add': 'Write Note',
  'notebooks.notes.empty.title': 'No notes yet',
  'notebooks.notes.empty.description': 'Create your first note to capture insights and observations.',
  'notebooks.notes.badge.ai': 'AI Generated',
  'notebooks.notes.badge.human': 'Human',
  'notebooks.notes.delete.title': 'Delete Note',
  'notebooks.notes.delete.description': 'Are you sure you want to delete this note? This action cannot be undone.',
  'notebooks.notes.delete.cta': 'Delete',
}

const notebooksChat = {
  'notebooks.chat.title': 'Chat with Notebook',
  'notebooks.chat.title.source': 'Chat with Source',
  'notebooks.chat.error.title': 'Unable to load chat',
  'notebooks.chat.error.hint': 'Please try refreshing the page',
  'notebooks.chat.error.notFound': 'This {type} could not be found',
  'notebooks.chat.empty.start': 'Start a conversation about this {contextType}',
  'notebooks.chat.empty.hint': 'Ask questions to understand the content better',
  'notebooks.chat.input.placeholder': 'Ask a question about this {contextType}...',
  'notebooks.chat.input.send': 'to send',
  'notebooks.chat.sessions': 'Sessions',
  'notebooks.chat.sessions.title': 'Chat Sessions',
  'notebooks.chat.sessions.loading': 'Loading sessions...',
  'notebooks.chat.sessions.empty': 'No chat sessions yet',
  'notebooks.chat.sessions.emptyHint': 'Create a session to start chatting',
  'notebooks.chat.sessions.create': 'Create',
  'notebooks.chat.sessions.cancel': 'Cancel',
  'notebooks.chat.sessions.placeholder': 'Session title...',
  'notebooks.chat.sessions.messages': '{count} messages',
  'notebooks.chat.sessions.delete.title': 'Delete Chat Session?',
  'notebooks.chat.sessions.delete.description': 'This action cannot be undone. All messages in this session will be permanently deleted.',
  'notebooks.chat.sessions.delete.confirm': 'Delete',
  'notebooks.chat.model.label': 'Model',
  'notebooks.chat.context.source': 'source',
  'notebooks.chat.context.sources': 'sources',
  'notebooks.chat.context.insight': 'insight',
  'notebooks.chat.context.insights': 'insights',
  'notebooks.chat.context.note': 'note',
  'notebooks.chat.context.notes': 'notes',
  'notebooks.chat.context.notebook': 'notebook',
  'notebooks.chat.context.notebooks': 'notebooks',
  'notebooks.chat.references': 'References',
  'notebooks.chat.ocr.label': 'Enable Document Image OCR',
  'notebooks.chat.ocr.tooltip': 'Enable Optical Character Recognition for images and text in documents',
}

const notebooksEditor = {
  'notebooks.editor.editTitle': 'Edit note',
  'notebooks.editor.createTitle': 'Create note',
  'notebooks.editor.placeholder.title': 'Add a title...',
  'notebooks.editor.placeholder.untitled': 'Untitled Note',
  'notebooks.editor.placeholder.content': 'Write your note content here...',
  'notebooks.editor.loading': 'Loading note…',
  'notebooks.editor.actions.cancel': 'Cancel',
  'notebooks.editor.actions.saving': 'Saving...',
  'notebooks.editor.actions.creating': 'Creating...',
  'notebooks.editor.actions.save': 'Save Note',
  'notebooks.editor.actions.create': 'Create Note',
  'notebooks.editor.validation.contentRequired': 'Content is required',
}

const notebookAssociations = {
  'notebookAssociations.title': 'Notebooks',
  'notebookAssociations.description': 'Manage which notebooks contain this source',
  'notebookAssociations.noNotebooks': 'No notebooks available',
  'notebookAssociations.save': 'Save Changes',
}

const commonCommandPalette = {
  'commandPalette.title': 'Command Palette',
  'commandPalette.description': 'Navigate, search, or ask your knowledge base',
  'commandPalette.placeholder': 'Type a command or search...',
  'commandPalette.section.searchAsk': 'Search & Ask',
  'commandPalette.section.navigation': 'Navigation',
  'commandPalette.section.notebooks': 'Notebooks',
  'commandPalette.section.create': 'Create',
  'commandPalette.section.theme': 'Theme',
  'commandPalette.section.searchPrompt': 'Or search your knowledge base',
  'commandPalette.search.label': 'Search for “{query}”',
  'commandPalette.ask.label': 'Ask about “{query}”',
  'commandPalette.notebooks.loading': 'Loading notebooks...',
  'commandPalette.create.source': 'Create Source',
  'commandPalette.create.notebook': 'Create Notebook',
  'commandPalette.create.podcast': 'Create Podcast',
  'commandPalette.theme.light': 'Light Theme',
  'commandPalette.theme.dark': 'Dark Theme',
  'commandPalette.theme.system': 'System Theme',
}

const commonAddButton = {
  'addButton.add': 'Add',
  'addButton.source': 'Source',
  'addButton.notebook': 'Notebook',
  'addButton.notebook.soon': 'Coming soon',
}

const commonTheme = {
  'theme.toggle.label': 'Theme',
  'theme.toggle.sr': 'Toggle theme',
  'theme.option.light': 'Light',
  'theme.option.dark': 'Dark',
  'theme.option.system': 'System',
}

const commonActions = {
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.stay_tuned': 'Stay Tuned',
  'common.loading': 'Loading...',
  'common.auto_refresh_on': 'Auto Refresh On',
  'common.auto_refresh_off': 'Auto Refresh Off',
}

const commonConfirmDialog = {
  'confirmDialog.confirm': 'Confirm',
  'confirmDialog.cancel': 'Cancel',
}

const commonErrorBoundary = {
  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.description': 'An unexpected error occurred. Please try refreshing the page.',
  'errorBoundary.details': 'Error Details',
  'errorBoundary.tryAgain': 'Try Again',
  'errorBoundary.refresh': 'Refresh Page',
}

const commonConnection = {
  'connection.api.unreachable.title': 'Unable to Connect to API Server',
  'connection.api.unreachable.subtitle': 'The FishOwn Agent API server could not be reached',
  'connection.db.offline.title': 'Database Connection Failed',
  'connection.db.offline.subtitle': 'The API server is running, but the database is not accessible',
  'connection.guide.heading': 'This usually means:',
  'connection.guide.api.item1': 'The API server is not running',
  'connection.guide.api.item2': 'The API server is running on a different address',
  'connection.guide.api.item3': 'Network connectivity issues',
  'connection.guide.db.item1': 'PostgreSQL is not running',
  'connection.guide.db.item2': 'Database connection settings are incorrect',
  'connection.guide.db.item3': 'Network issues between API and database',
  'connection.quick.heading': 'Quick fixes:',
  'connection.quick.api.title': 'Set the API_URL environment variable:',
  'connection.quick.db.title': 'Check if PostgreSQL is running:',
  'connection.docs.prefix': 'For detailed setup instructions, see:',
  'connection.docs.link': 'FishOwn Agent Documentation',
  'connection.details.toggle': 'Show Technical Details',
  'connection.details.attemptedUrl': 'Attempted URL:',
  'connection.details.message': 'Message:',
  'connection.details.technical': 'Technical Details:',
  'connection.details.stack': 'Stack Trace:',
  'connection.retry': 'Retry Connection',
  'connection.retry.hint': 'Press R or click the button to retry',
  'connection.error.unknown': 'Unknown error occurred',
}

const commonModelSelector = {
  'modelSelector.placeholder': 'Select a model',
  'modelSelector.empty.language': 'No language models available',
  'modelSelector.empty.embedding': 'No embedding models available',
  'modelSelector.empty.speech_to_text': 'No speech-to-text models available',
  'modelSelector.empty.text_to_speech': 'No text-to-speech models available',
  'modelSelector.empty.generic': 'No models available',
}

const modelSelectorDialog = {
  'modelSelector.dialog.title': 'Model Configuration',
  'modelSelector.dialog.description': 'Override the default model for this chat session. Leave empty to use the system default.',
  'modelSelector.dialog.label': 'Model',
  'modelSelector.dialog.placeholder': 'Select a model (or use default)',
  'modelSelector.dialog.defaultWithModel': 'Default ({model})',
  'modelSelector.dialog.systemDefault': 'System Default',
  'modelSelector.dialog.usingCustom': 'This session will use <strong>{model}</strong> instead of the default model.',
  'modelSelector.dialog.reset': 'Reset to Default',
  'modelSelector.dialog.save': 'Save Changes',
  'modelSelector.dialog.defaultModel': 'Default Model',
}

const commonContextToggle = {
  'contextToggle.off': 'Not included in chat',
  'contextToggle.insights': 'Insights only',
  'contextToggle.full': 'Full content',
  'contextToggle.cycle': 'Click to cycle',
}

const commonContextIndicator = {
  'contextIndicator.empty': 'No sources or notes included in context. Toggle icons on cards to include them.',
  'contextIndicator.label': 'Context:',
  'contextIndicator.tooltip.insights': 'Insights for {count} source(s)',
  'contextIndicator.tooltip.sources': '{count} full source(s)',
  'contextIndicator.tooltip.notes': '{count} full note(s)',
  'contextIndicator.tokens': '{count} tokens',
  'contextIndicator.chars': '{count} chars',
}

const searchPage = {
  'search.page.title': 'Ask and Search',
  'search.page.mode.label': 'Choose a mode',
  'search.page.mode.ariaLabel': 'Ask or search your knowledge base',
  'search.page.mode.ask': 'Ask (beta)',
  'search.page.mode.search': 'Search',
  'search.ask.title': 'Ask Your Knowledge Base (beta)',
  'search.ask.description': 'The LLM will answer your query based on the documents in your knowledge base.',
  'search.ask.question.label': 'Question',
  'search.ask.question.placeholder': 'Enter your question...',
  'search.ask.question.shortcut': 'Press Cmd/Ctrl+Enter to submit',
  'search.ask.error.noEmbeddingModel': "You can't use this feature because you have no embedding model selected. Please set one up in the Models page.",
  'search.ask.models.custom': 'Using Custom Models',
  'search.ask.models.default': 'Using Default Models',
  'search.ask.models.advanced': 'Advanced',
  'search.ask.models.strategy': 'Strategy: {model}',
  'search.ask.models.answer': 'Answer: {model}',
  'search.ask.models.final': 'Final: {model}',
  'search.ask.models.notSet': 'Not set',
  'search.ask.actions.processing': 'Processing...',
  'search.ask.actions.ask': 'Ask',
  'search.ask.actions.saveToNotebooks': 'Save to Notebooks',
  'search.search.title': 'Search',
  'search.search.description': 'Search your knowledge base for specific keywords or concepts',
  'search.search.query.placeholder': 'Enter search query...',
  'search.search.actions.search': 'Search',
  'search.search.query.shortcut': 'Press Enter to search',
  'search.search.options.type.label': 'Search Type',
  'search.search.options.type.noEmbeddingModel': 'Vector search requires an embedding model. Only text search is available.',
  'search.search.options.type.text': 'Text Search',
  'search.search.options.type.vector': 'Vector Search',
  'search.search.options.location.label': 'Search In',
  'search.search.options.location.sources': 'Search Sources',
  'search.search.options.location.notes': 'Search Notes',
  'search.results.count': '{count, plural, =0 {No results} one {# result} other {# results}} found',
  'search.results.type': '{type} search',
  'search.results.empty': 'No results found for "{query}"',
  'search.results.matches': 'Matches ({count})',
}

const sourcesPage = {
  'sources.page.title': 'All Sources',
  'sources.page.description': 'Browse all sources across your notebooks. Use arrow keys to navigate and Enter to open.',
  'sources.page.empty.title': 'No sources yet',
  'sources.page.empty.description': 'Sources from all notebooks will appear here',
  'sources.page.error.load': 'Failed to load sources',
  'sources.page.error.delete': 'Failed to delete source',
  'sources.page.success.delete': 'Source deleted successfully',
  'sources.page.table.type': 'Type',
  'sources.page.table.title': 'Title',
  'sources.page.table.created': 'Created',
  'sources.page.table.insights': 'Insights',
  'sources.page.table.embedded': 'Embedded',
  'sources.page.table.actions': 'Actions',
  'sources.page.type.link': 'Link',
  'sources.page.type.file': 'File',
  'sources.page.type.text': 'Text',
  'sources.page.type.unknown': 'Unknown',
  'sources.page.untitled': 'Untitled Source',
  'sources.page.embedded.yes': 'Yes',
  'sources.page.embedded.no': 'No',
  'sources.page.loadingMore': 'Loading more sources...',
  'sources.page.delete.title': 'Delete Source',
  'sources.page.delete.description': 'Are you sure you want to delete "{title}"? This action cannot be undone.',
  'sources.page.delete.cta': 'Delete',
}

const auth = {
  'auth.login.title': 'FishOwn Agent',
  'auth.login.description': 'Sign in through the remote authentication portal.',
  'auth.login.remote.iframeTitle': 'Remote authentication portal',
  'auth.login.remote.waiting': 'Waiting for the remote login portal to finish...',
  'auth.login.remote.missingUrl': 'Remote login URL is not configured.',
  'auth.login.remote.missingUrlDescription':
    'Set NEXT_PUBLIC_REMOTE_LOGIN_URL to the remote login page before starting the dashboard.',
  'auth.login.passwordPlaceholder': 'Password',
  'auth.login.signIn': 'Sign In',
  'auth.login.signingIn': 'Signing in...',
  'auth.login.error.connection.title': 'Connection Error',
  'auth.login.error.connection.description': 'Unable to connect to the API server',
  'auth.login.error.connection.detailed': 'Unable to connect to server. Please check if the API is running.',
  'auth.login.error.diagnostics.title': 'Diagnostic Information:',
  'auth.login.error.diagnostics.version': 'Version: {version}',
  'auth.login.error.diagnostics.built': 'Built: {buildTime}',
  'auth.login.error.diagnostics.apiUrl': 'API URL: {apiUrl}',
  'auth.login.error.diagnostics.frontend': 'Frontend: {url}',
  'auth.login.error.diagnostics.checkConsole': 'Check browser console for detailed logs (look for 🔧 [Config] messages)',
  'auth.login.error.retry': 'Retry Connection',
}

const imageGeneratorPage = {
  'image_generator.page.title': 'Image Generator',
  'image_generator.page.description': 'Generate images using various AI models.',
  'image_generator.tab.nano_banana_pro': 'Nano Banana Pro',
  'image_generator.tab.midjourney_v7': 'Midjourney V7',
}

const podcastsPage = {
  'podcasts.page.title': 'Podcasts',
  'podcasts.page.description': 'Keep track of generated episodes and manage reusable templates.',
  'podcasts.page.view.label': 'Choose a view',
  'podcasts.page.view.ariaLabel': 'Podcast views',
  'podcasts.page.view.episodes': 'Episodes',
  'podcasts.page.view.templates': 'Templates',
  'podcasts.episodes.title': 'Episodes overview',
  'podcasts.episodes.description': 'Monitor podcast generation jobs and review the final artefacts.',
  'podcasts.episodes.generate': 'Generate Podcast',
  'podcasts.episodes.refresh': 'Refresh',
  'podcasts.episodes.summary.total': 'Total',
  'podcasts.episodes.summary.processing': 'Processing',
  'podcasts.episodes.summary.completed': 'Completed',
  'podcasts.episodes.summary.failed': 'Failed',
  'podcasts.episodes.summary.pending': 'Pending',
  'podcasts.episodes.error.load.title': 'Failed to load episodes',
  'podcasts.episodes.error.load.description': 'We could not fetch the latest podcast episodes. Try again shortly.',
  'podcasts.episodes.loading': 'Loading episodes…',
  'podcasts.episodes.empty': 'No podcast episodes yet. Generate your first one from the notebook or source chat interfaces.',
  'podcasts.episodes.status.running.title': 'Currently Processing',
  'podcasts.episodes.status.running.description': 'Episodes that are actively generating assets.',
  'podcasts.episodes.status.pending.title': 'Queued / Pending',
  'podcasts.episodes.status.pending.description': 'Submitted episodes waiting to start processing.',
  'podcasts.episodes.status.completed.title': 'Completed Episodes',
  'podcasts.episodes.status.completed.description': 'Ready to review, download, or publish.',
  'podcasts.episodes.status.failed.title': 'Failed Episodes',
  'podcasts.episodes.status.failed.description': 'Episodes that encountered issues during generation.',
  'podcasts.templates.title': 'Templates workspace',
  'podcasts.templates.description': 'Build reusable episode and speaker configurations for fast podcast production.',
  'podcasts.templates.overview.title': 'How templates power podcast generation',
  'podcasts.templates.overview.description': 'Templates split the podcast workflow into two reusable building blocks. Mix and match them whenever you generate a new episode.',
  'podcasts.templates.overview.episodeProfiles.title': 'Episode profiles set the format',
  'podcasts.templates.overview.episodeProfiles.item1': 'Outline the number of segments and how the story flows',
  'podcasts.templates.overview.episodeProfiles.item2': 'Pick the language models used for briefing, outlining, and script writing',
  'podcasts.templates.overview.episodeProfiles.item3': 'Store default briefings so every episode starts with a consistent tone',
  'podcasts.templates.overview.speakerProfiles.title': 'Speaker profiles bring voices to life',
  'podcasts.templates.overview.speakerProfiles.item1': 'Choose the text-to-speech provider and model',
  'podcasts.templates.overview.speakerProfiles.item2': 'Capture personality, backstory, and pronunciation notes per speaker',
  'podcasts.templates.overview.speakerProfiles.item3': 'Reuse the same host or guest voices across different episode formats',
  'podcasts.templates.overview.workflow.title': 'Recommended workflow',
  'podcasts.templates.overview.workflow.item1': 'Create speaker profiles for each voice you need',
  'podcasts.templates.overview.workflow.item2': 'Build episode profiles that reference those speakers by name',
  'podcasts.templates.overview.workflow.item3': 'Generate podcasts by selecting the episode profile that fits the story',
  'podcasts.templates.overview.workflow.note': 'Episode profiles reference speaker profiles by name, so starting with speakers avoids missing voice assignments later.',
  'podcasts.templates.error.load.title': 'Failed to load templates data',
  'podcasts.templates.error.load.description': 'Ensure the API is running and try again. Some sections may be incomplete.',
  'podcasts.templates.loading': 'Loading templates…',
}

const addSourceDialog = {
  'addSourceDialog.title': 'Add New Source',
  'addSourceDialog.description': 'Add content from links, uploads, or text to your notebooks.',
  'addSourceDialog.step1.title': 'Source & Content',
  'addSourceDialog.step1.description': 'Choose type and add content',
  'addSourceDialog.step2.title': 'Organization',
  'addSourceDialog.step2.description': 'Select notebooks',
  'addSourceDialog.step3.title': 'Processing',
  'addSourceDialog.step3.description': 'Choose transformations and options',
  'addSourceDialog.validation.required': 'Please provide the required content for the selected source type',
  'addSourceDialog.validation.titleRequired': 'Title is required for text sources',
  'addSourceDialog.processing.batchMessage': 'Processing {itemCount} sources...',
  'addSourceDialog.processing.batchSuccess': '{successCount} source(s) created successfully',
  'addSourceDialog.processing.batchFailed': 'Failed to create all {failedCount} sources',
  'addSourceDialog.processing.batchPartial': '{successCount} succeeded, {failedCount} failed',
  'addSourceDialog.processing.singleMessage': 'Submitting source for processing...',
  'addSourceDialog.processing.errorMessage': 'Error creating source. Please try again.',
  'addSourceDialog.processing.batchTitle': 'Processing Batch',
  'addSourceDialog.processing.singleTitle': 'Processing Source',
  'addSourceDialog.processing.batchDescription': 'Processing {total} sources. This may take a few moments.',
  'addSourceDialog.processing.singleDescription': 'Your source is being processed. This may take a few moments.',
  'addSourceDialog.processing.label': 'Processing...',
  'addSourceDialog.processing.completed': '{completed} completed',
  'addSourceDialog.processing.failed': '{failed} failed',
  'addSourceDialog.processing.currentItem': 'Current: {currentItem}',
  'addSourceDialog.actions.cancel': 'Cancel',
  'addSourceDialog.actions.back': 'Back',
  'addSourceDialog.actions.next': 'Next',
  'addSourceDialog.actions.creating': 'Creating...',
  'addSourceDialog.actions.done': 'Done',
  'addSourceDialog.type.link.label': 'Link',
  'addSourceDialog.type.link.description': 'Add a web page or URL',
  'addSourceDialog.type.upload.label': 'Upload',
  'addSourceDialog.type.upload.description': 'Upload a document or file',
  'addSourceDialog.type.text.label': 'Text',
  'addSourceDialog.type.text.description': 'Add text content directly',
  'addSourceDialog.type.title': 'Source Type',
  'addSourceDialog.type.description': 'Choose how you want to add your content',
  'addSourceDialog.type.link.labelUrl': 'URL(s) *',
  'addSourceDialog.type.link.urlCount': '{count} URL',
  'addSourceDialog.type.link.urlCount_plural': '{count} URLs',
  'addSourceDialog.type.maxSize': 'max {size}',
  'addSourceDialog.type.link.placeholder': 'Enter URLs, one per line\nhttps://example.com/article1\nhttps://example.com/article2',
  'addSourceDialog.type.link.batchHint': 'Paste multiple URLs (one per line) to batch import',
  'addSourceDialog.type.link.invalidUrlError': 'Invalid URLs detected:',
  'addSourceDialog.type.link.line': 'Line {line}',
  'addSourceDialog.type.link.fixInvalidUrlHint': 'Please fix or remove invalid URLs to continue',
  'addSourceDialog.type.upload.labelFile': 'File(s) *',
  'addSourceDialog.type.upload.fileCount': '{count} file',
  'addSourceDialog.type.upload.fileCount_plural': '{count} files',
  'addSourceDialog.type.upload.batchHint': 'Select multiple files to batch import. Supported: Documents (PDF, DOC, DOCX, PPT, XLS, EPUB, TXT, MD), Media (MP4, MP3, WAV, M4A), Images (JPG, PNG), Archives (ZIP)',
  'addSourceDialog.type.upload.selectedFiles': 'Selected files:',
  'addSourceDialog.type.upload.fileSize': '{size} KB',
  'addSourceDialog.type.upload.maxSizeError': 'Maximum {size} files allowed per batch',
  'addSourceDialog.type.text.labelContent': 'Text Content *',
  'addSourceDialog.type.text.placeholder': 'Paste or type your content here...',
  'addSourceDialog.title.required': 'Title *',
  'addSourceDialog.title.optional': 'Title (optional)',
  'addSourceDialog.title.textHint': 'A title is required for text content',
  'addSourceDialog.title.genericHint': 'If left empty, a title will be generated from the content',
  'addSourceDialog.title.placeholder': 'Give your source a descriptive title',
  'addSourceDialog.batchMode.title': 'Batch Mode',
  'addSourceDialog.batchMode.description': '{count} {type} will be processed',
  'addSourceDialog.batchMode.hint': 'Titles will be automatically generated for each source. The same notebooks and transformations will be applied to all items.',
  'addSourceDialog.step2.notebooks.title': 'Select Notebooks (optional)',
  'addSourceDialog.step2.notebooks.description': 'Choose which notebooks should contain this source. You can select multiple notebooks or leave this empty.',
  'addSourceDialog.step2.notebooks.empty': 'No notebooks found.',
  'addSourceDialog.step3.transformations.title': 'Transformations (optional)',
  'addSourceDialog.step3.transformations.description': 'Apply AI transformations to analyze and extract insights from your content.',
  'addSourceDialog.step3.transformations.empty': 'No transformations found.',
  'addSourceDialog.step3.processing.title': 'Processing Settings',
  'addSourceDialog.step3.processing.description': 'Configure how your source will be processed and stored.',
  'addSourceDialog.step3.processing.embed.label': 'Enable embedding for search',
  'addSourceDialog.step3.processing.embed.description': 'Allows this source to be found in vector searches and AI queries',
  'addSourceDialog.step3.processing.embed.auto.label': 'Embedding enabled automatically',
  'addSourceDialog.step3.processing.embed.auto.description': 'Your settings are configured to always embed content for vector search. You can change this in {settingsLink}.',
  'addSourceDialog.step3.processing.embed.disabled.label': 'Embedding disabled',
  'addSourceDialog.step3.processing.embed.disabled.description': "Your settings are configured to skip embedding. Vector search won't be available for this source. You can change this in {settingsLink}.",
  'addSourceDialog.error.noTransformationModel': "You can't create insights because no language model is selected. Please set one up in the Models page.",
  'addSourceDialog.error.noOcrModel': 'Unable to enable OCR as no OCR model is selected. Please configure one in the Models page.',
  'addSourceDialog.step3.processing.graphrag.label': 'Enable knowledge graph indexing (GraphRAG)',
  'addSourceDialog.step3.processing.graphrag.description': 'Build entity and relationship graphs for complex Q&A and knowledge discovery',
}

const addExistingSourceDialog = {
  'addExistingSourceDialog.title': 'Add Existing Sources',
  'addExistingSourceDialog.description': 'Search and select existing sources to add to this notebook',
  'addExistingSourceDialog.searchPlaceholder': 'Search sources...',
  'addExistingSourceDialog.loading': 'Loading sources...',
  'addExistingSourceDialog.noResults': 'No sources found',
  'addExistingSourceDialog.untitled': 'Untitled',
  'addExistingSourceDialog.linked': 'Linked',
  'addExistingSourceDialog.addedOn': 'Added {date}',
  'addExistingSourceDialog.truncationWarning': 'Showing first 100 sources. Use the Search feature to find specific sources.',
  'addExistingSourceDialog.selectionCount': 'Selected {count} sources',
  'addExistingSourceDialog.selectionCount_plural': 'Selected {count} sources',
  'addExistingSourceDialog.actions.cancel': 'Cancel',
  'addExistingSourceDialog.actions.adding': 'Adding...',
  'addExistingSourceDialog.actions.addSelected': 'Add Selected',
}

const createNotebookDialog = {
  'createNotebookDialog.title': 'Create New Notebook',
  'createNotebookDialog.description': 'Create a dedicated space for related sources and notes to start organizing your research.',
  'createNotebookDialog.name.label': 'Name *',
  'createNotebookDialog.name.placeholder': 'Enter notebook name',
  'createNotebookDialog.name.required': 'Name is required',
  'createNotebookDialog.description.label': 'Description',
  'createNotebookDialog.description.placeholder': 'Describe the purpose and scope of this notebook...',
  'createNotebookDialog.actions.cancel': 'Cancel',
  'createNotebookDialog.actions.creating': 'Creating…',
  'createNotebookDialog.actions.create': 'Create Notebook',
}

const collapsibleColumn = {
  'collapsibleColumn.expand': 'Expand {label}',
  'collapsibleColumn.collapse': 'Collapse {label}',
}

const modelsPage = {
  'models.page.loadError': 'Failed to load model data',
  'models.page.title': 'Model Management',
  'models.page.description': 'Configure AI models for different purposes across FishOwn Agent',
}

const providerStatus = {
  'providerStatus.title': 'AI Providers',
  'providerStatus.description': 'Configure providers through environment variables to enable their models.',
  'providerStatus.configured': '{count} of {total} configured',
  'providerStatus.noModels': 'No models',
  'providerStatus.notConfigured': 'Not configured',
  'providerStatus.seeLess': 'See less',
  'providerStatus.seeAll': 'See all {count} providers',
  'providerStatus.learnMore': 'Learn how to configure providers →',
  'providerStatus.type.language': 'Language',
  'providerStatus.type.embedding': 'Embedding',
  'providerStatus.type.text_to_speech': 'Text to Speech',
  'providerStatus.type.speech_to_text': 'Speech to Text',
  'providerStatus.type.ocr': 'OCR',
}

const providerSettings = {
  'providerSettings.title': 'Configure {provider}',
  'providerSettings.description': 'Enter your API keys and other configuration details.',
  'providerSettings.placeholder': 'Enter {key}',
  'providerSettings.noSettings': 'No configuration needed for this provider.',
  'providerSettings.validation.required': 'This field is required.',
  'providerSettings.field.api_key': 'API Key',
  'providerSettings.field.base_url': 'Base URL',
  'providerSettings.field.timeout': 'Timeout (s)',
  'providerSettings.field.max_tokens': 'Max Tokens',
  'providerSettings.field.temperature': 'Temperature',
  'providerSettings.field.gemini_api_key': 'Gemini API Key',
  'providerSettings.field.project': 'Project',
  'providerSettings.field.location': 'Location',
  'providerSettings.field.credentials': 'Credentials JSON Path',
  'providerSettings.field.endpoint': 'Endpoint',
  'providerSettings.field.api_version': 'API Version',
}

const modelTypeSection = {
  'modelTypeSection.languageModels.title': 'Language Models',
  'modelTypeSection.languageModels.description': 'Chat, transformations, and text generation',
  'modelTypeSection.embeddingModels.title': 'Embedding Models',
  'modelTypeSection.embeddingModels.description': 'Semantic search and vector embeddings',
  'modelTypeSection.textToSpeech.title': 'Text-to-Speech',
  'modelTypeSection.textToSpeech.description': 'Generate audio from text',
  'modelTypeSection.speechToText.title': 'Speech-to-Text',
  'modelTypeSection.speechToText.description': 'Transcribe audio to text',
  'modelTypeSection.ocrModels.title': 'OCR Models',
  'modelTypeSection.ocrModels.description': 'Optical Character Recognition',
  'modelTypeSection.filter.all': 'All',
  'modelTypeSection.noModels.configured': 'No models configured',
  'modelTypeSection.noModels.providerConfigured': 'No {provider} models configured',
  'modelTypeSection.noModels.badge': 'No models',
  'modelTypeSection.notConfigured.badge': 'Not configured',
  'modelTypeSection.showLess': 'Show less',
  'modelTypeSection.showMore': 'Show {count} more',
  'modelTypeSection.deleteModel.title': 'Delete Model',
  'modelTypeSection.deleteModel.description': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
  'modelTypeSection.deleteModel.confirm': 'Delete',
  'modelTypeSection.dimension': 'Dim: {dim}',
}

const defaultModelsSection = {
  'defaultModelsSection.title': 'Default Model Assignments',
  'defaultModelsSection.description': 'Configure which models to use for different purposes across FishOwn Agent',
  'defaultModelsSection.chatModel.label': 'Chat Model',
  'defaultModelsSection.chatModel.description': 'Used for chat conversations',
  'defaultModelsSection.transformationModel.label': 'Transformation Model',
  'defaultModelsSection.transformationModel.description': 'Used for summaries, insights, and transformations',
  'defaultModelsSection.toolsModel.label': 'Tools Model',
  'defaultModelsSection.toolsModel.description': 'Used for function calling - OpenAI or Anthropic recommended',
  'defaultModelsSection.largeContextModel.label': 'Large Context Model',
  'defaultModelsSection.largeContextModel.description': 'Used for processing large documents - Gemini recommended',
  'defaultModelsSection.ocrModel.label': 'OCR Model',
  'defaultModelsSection.ocrModel.description': 'Used for extracting text from images and documents',
  'defaultModelsSection.embeddingModel.label': 'Embedding Model',
  'defaultModelsSection.embeddingModel.description': 'Used for semantic search and vector embeddings',
  'defaultModelsSection.textToSpeechModel.label': 'Text-to-Speech Model',
  'defaultModelsSection.textToSpeechModel.description': 'Used for podcast generation',
  'defaultModelsSection.speechToTextModel.label': 'Speech-to-Text Model',
  'defaultModelsSection.speechToTextModel.description': 'Used for audio transcription',
  'defaultModelsSection.missingRequired': 'Missing required models: {models}. FishOwn Agent may not function properly without these.',
  'defaultModelsSection.selectModel.required': '⚠️ Required - Select a model',
  'defaultModelsSection.selectModel.placeholder': 'Select a model',
  'defaultModelsSection.learnMore': 'Which model should I choose? →',
}

const addModelForm = {
  'addModelForm.button': 'Add Model',
  'addModelForm.dialog.title': 'Add {type} Model',
  'addModelForm.dialog.description': 'Configure a new {type} model from available providers.',
  'addModelForm.noProviders': 'No providers available for {type} models',
  'addModelForm.provider.label': 'Provider',
  'addModelForm.provider.placeholder': 'Select a provider',
  'addModelForm.provider.required': 'Provider is required',
  'addModelForm.name.label': 'Model Name',
  'addModelForm.name.required': 'Model name is required',
  'addModelForm.name.placeholder.language': 'e.g., gpt-5-mini, claude, gemini',
  'addModelForm.name.placeholder.embedding': 'e.g., text-embedding-3-small',
  'addModelForm.name.placeholder.textToSpeech': 'e.g., tts-gpt-4o-mini-tts, tts-1-hd',
  'addModelForm.name.placeholder.speechToText': 'e.g., whisper-1',
  'addModelForm.name.placeholder.ocr': 'e.g., gpt-4-o, gemma2-9b-it',
  'addModelForm.name.placeholder.default': 'Enter model name',
  'addModelForm.name.azureHint': 'For Azure, use the deployment name as the model name',
  'addModelForm.actions.cancel': 'Cancel',
  'addModelForm.actions.adding': 'Adding...',
  'addModelForm.actions.addModel': 'Add Model',
}

const embeddingModelChangeDialog = {
  'embeddingModelChangeDialog.title': 'Embedding Model Change',
  'embeddingModelChangeDialog.description.intro': 'You are about to change your embedding model',
  'embeddingModelChangeDialog.description.fromTo': 'from **{oldModelName}** to **{newModelName}**',
  'embeddingModelChangeDialog.description.important': 'Important: Rebuild Required',
  'embeddingModelChangeDialog.description.rebuildWarning': 'Changing your embedding model requires rebuilding all existing embeddings to maintain consistency. Without rebuilding, your searches may return incorrect or incomplete results.',
  'embeddingModelChangeDialog.description.whatHappensNext': 'What happens next:',
  'embeddingModelChangeDialog.description.updated': 'Your default embedding model will be updated',
  'embeddingModelChangeDialog.description.unchanged': 'Existing embeddings will remain unchanged until rebuild',
  'embeddingModelChangeDialog.description.newContent': 'New content will use the new embedding model',
  'embeddingModelChangeDialog.description.rebuildSoon': 'You should rebuild embeddings as soon as possible',
  'embeddingModelChangeDialog.description.proceedQuestion': 'Would you like to proceed to the Advanced page to start the rebuild now?',
  'embeddingModelChangeDialog.actions.cancel': 'Cancel',
  'embeddingModelChangeDialog.actions.changeModelOnly': 'Change Model Only',
  'embeddingModelChangeDialog.actions.changeAndRebuild': 'Change & Go to Rebuild',
}

const podcasts = {
  'podcasts.page.episodeCard.status.processing': 'Processing',
  'podcasts.page.episodeCard.status.completed': 'Completed',
  'podcasts.page.episodeCard.status.failed': 'Failed',
  'podcasts.page.episodeCard.status.pending': 'Pending',
  'podcasts.page.episodeCard.status.unknown': 'Unknown',
  'podcasts.page.episodeCard.audioUnavailable': 'Audio unavailable',
  'podcasts.page.episodeCard.profile': 'Profile',
  'podcasts.page.episodeCard.unknown': 'Unknown',
  'podcasts.page.episodeCard.created': 'Created',
  'podcasts.page.episodeCard.details': 'Details',
  'podcasts.page.episodeCard.unknownProfile': 'Unknown profile',
  'podcasts.page.episodeCard.summary': 'Summary',
  'podcasts.page.episodeCard.outline': 'Outline',
  'podcasts.page.episodeCard.transcript': 'Transcript',
  'podcasts.page.episodeCard.episodeProfile': 'Episode Profile',
  'podcasts.page.episodeCard.outlineModel': 'Outline Model',
  'podcasts.page.episodeCard.transcriptModel': 'Transcript Model',
  'podcasts.page.episodeCard.segments': 'Segments',
  'podcasts.page.episodeCard.speakerProfile': 'Speaker Profile',
  'podcasts.page.episodeCard.voiceId': 'Voice ID',
  'podcasts.page.episodeCard.backstory': 'Backstory',
  'podcasts.page.episodeCard.personality': 'Personality',
  'podcasts.page.episodeCard.briefing': 'Briefing',
  'podcasts.page.episodeCard.segment': 'Segment',
  'podcasts.page.episodeCard.noDescriptionProvided': 'No description provided.',
  'podcasts.page.episodeCard.noOutlineAvailable': 'No outline available.',
  'podcasts.page.episodeCard.speaker': 'Speaker',
  'podcasts.page.episodeCard.noTranscriptAvailable': 'No transcript available.',
  'podcasts.page.episodeCard.delete': 'Delete',
  'podcasts.page.episodeCard.deleteEpisode': 'Delete episode?',
  'podcasts.page.episodeCard.deleteEpisodeDescription': 'This will remove “{name}” and its audio file permanently.',
  'podcasts.page.episodeCard.cancel': 'Cancel',
  'podcasts.page.episodeCard.deleting': 'Deleting…',

  'podcasts.episodeProfiles.title': 'Episode profiles',
  'podcasts.episodeProfiles.description': 'Define reusable generation settings for your shows.',
  'podcasts.episodeProfiles.createProfile': 'Create profile',
  'podcasts.episodeProfiles.noSpeakerProfileWarning': 'Create a speaker profile before adding an episode profile.',
  'podcasts.episodeProfiles.noEpisodeProfiles': 'No episode profiles yet. Create one to kickstart podcast generation.',
  'podcasts.episodeProfiles.noDescription': 'No description provided.',
  'podcasts.episodeProfiles.edit': 'Edit',
  'podcasts.episodeProfiles.duplicate': 'Duplicate',
  'podcasts.episodeProfiles.delete': 'Delete',
  'podcasts.episodeProfiles.deleteProfileTitle': 'Delete profile?',
  'podcasts.episodeProfiles.deleteProfileDescription': 'This will remove “{name}”. Existing episodes keep their data, but new ones will no longer use this configuration.',
  'podcasts.episodeProfiles.cancel': 'Cancel',
  'podcasts.episodeProfiles.deleting': 'Deleting…',
  'podcasts.episodeProfiles.outlineModel': 'Outline model',
  'podcasts.episodeProfiles.transcriptModel': 'Transcript model',
  'podcasts.episodeProfiles.segments': 'Segments',
  'podcasts.episodeProfiles.speakerProfile': 'Speaker profile',
  'podcasts.episodeProfiles.defaultBriefing': 'Default briefing',

  'podcasts.speakerProfiles.title': 'Speaker profiles',
  'podcasts.speakerProfiles.description': 'Configure voices and personalities for generated episodes.',
  'podcasts.speakerProfiles.createSpeaker': 'Create speaker',
  'podcasts.speakerProfiles.noSpeakerProfiles': 'No speaker profiles yet. Create one to make episode templates available.',
  'podcasts.speakerProfiles.noDescription': 'No description provided.',
  'podcasts.speakerProfiles.usageCount': 'Used by {count} episode(s)',
  'podcasts.speakerProfiles.unused': 'Unused',
  'podcasts.speakerProfiles.voiceId': 'Voice ID',
  'podcasts.speakerProfiles.backstory': 'Backstory',
  'podcasts.speakerProfiles.personality': 'Personality',
  'podcasts.speakerProfiles.edit': 'Edit',
  'podcasts.speakerProfiles.duplicate': 'Duplicate',
  'podcasts.speakerProfiles.delete': 'Delete',
  'podcasts.speakerProfiles.deleteProfileTitle': 'Delete speaker profile?',
  'podcasts.speakerProfiles.deleteProfileDescription': 'Deleting “{name}” cannot be undone.',
  'podcasts.speakerProfiles.deleteDisabledWarning': 'Remove this speaker from episode profiles before deleting it.',
  'podcasts.speakerProfiles.cancel': 'Cancel',
  'podcasts.speakerProfiles.deleting': 'Deleting…',

  'podcasts.generate.title': 'Generate Podcast Episode',
  'podcasts.generate.description': 'Select the content to include and configure the episode details before generating a new podcast episode.',
  'podcasts.generate.content.title': 'Content',
  'podcasts.generate.content.description': 'Pick notebooks, sources, and notes to include in this episode.',
  'podcasts.generate.content.itemsSelected': '{count} items selected',
  'podcasts.generate.content.tokens': '{count} tokens',
  'podcasts.generate.content.chars': '{count} chars',
  'podcasts.generate.notebooks.loading': 'Loading notebooks',
  'podcasts.generate.notebooks.empty': 'No notebooks found. Create a notebook and add content before generating a podcast.',
  'podcasts.generate.notebooks.selectionSummary': '{sources} sources, {notes} notes',
  'podcasts.generate.notebooks.noContentSelected': 'No content selected',
  'podcasts.generate.notebooks.contentSummary': '{sources} sources · {notes} notes',
  'podcasts.generate.sources.title': 'Sources',
  'podcasts.generate.sources.empty': 'No sources available in this notebook.',
  'podcasts.generate.sources.untitled': 'Untitled source',
  'podcasts.generate.sources.type.link': 'Link',
  'podcasts.generate.sources.type.file': 'File',
  'podcasts.generate.sources.status.embedded': 'Embedded',
  'podcasts.generate.sources.status.notEmbedded': 'Not embedded',
  'podcasts.generate.sources.selectModePlaceholder': 'Select mode',
  'podcasts.generate.notes.title': 'Notes',
  'podcasts.generate.notes.empty': 'No notes available in this notebook.',
  'podcasts.generate.notes.untitled': 'Untitled note',
  'podcasts.generate.notes.updated': 'Updated {date}',
  'podcasts.generate.settings.title': 'Episode Settings',
  'podcasts.generate.settings.loading': 'Loading episode profiles',
  'podcasts.generate.settings.noProfiles': 'No episode profiles found. Create an episode profile before generating a podcast.',
  'podcasts.generate.settings.episodeProfileLabel': 'Episode profile',
  'podcasts.generate.settings.episodeProfilePlaceholder': 'Select an episode profile',
  'podcasts.generate.settings.usesSpeakerProfile': 'Uses speaker profile <strong>{name}</strong>',
  'podcasts.generate.settings.episodeNameLabel': 'Episode name',
  'podcasts.generate.settings.episodeNamePlaceholder': 'e.g., AI and the Future of Work',
  'podcasts.generate.settings.additionalInstructionsLabel': 'Additional instructions',
  'podcasts.generate.settings.additionalInstructionsPlaceholder': 'Any supplemental guidance to append to the episode briefing...',
  'podcasts.generate.settings.additionalInstructionsDescription': "These instructions will be appended to the episode profile's default briefing.",
  'podcasts.generate.submitting': 'Generating episode...',
  'podcasts.generate.submit': 'Generate Podcast',
  'podcasts.generate.submitDescription': 'The episode will appear in the Episodes list once generation starts. Refresh the list to monitor progress.',
  'podcasts.generate.sourceModes.summary': 'Summary',
  'podcasts.generate.sourceModes.full': 'Full content',
  'podcasts.generate.errors.buildContext': 'Failed to build context. Please review your selections.',
  'podcasts.generate.errors.episodeProfileRequired.title': 'Episode profile required',
  'podcasts.generate.errors.episodeProfileRequired.description': 'Select an episode profile before generating a podcast.',
  'podcasts.generate.errors.episodeNameRequired.title': 'Episode name required',
  'podcasts.generate.errors.episodeNameRequired.description': 'Provide a name for the episode.',
  'podcasts.generate.errors.addContext.title': 'Add context',
  'podcasts.generate.errors.addContext.description': 'Select at least one source or note to include in the episode.',
  'podcasts.generate.errors.generationFailed.title': 'Podcast generation failed',
  'podcasts.generate.errors.generationFailed.description': 'Please try again later.',

  'podcasts.episodeProfileForm.editTitle': 'Edit Episode Profile',
  'podcasts.episodeProfileForm.createTitle': 'Create Episode Profile',
  'podcasts.episodeProfileForm.description': 'Define how episodes should be generated and which speaker configuration they use by default.',
  'podcasts.episodeProfileForm.noSpeakers.title': 'No speaker profiles available',
  'podcasts.episodeProfileForm.noSpeakers.description': 'Create a speaker profile before configuring an episode profile.',
  'podcasts.episodeProfileForm.noModels.title': 'No language models available',
  'podcasts.episodeProfileForm.noModels.description': 'Add language models in the Models section to configure outline and transcript generation.',
  'podcasts.episodeProfileForm.nameLabel': 'Profile name',
  'podcasts.episodeProfileForm.namePlaceholder': 'Tech discussion',
  'podcasts.episodeProfileForm.segmentsLabel': 'Segments',
  'podcasts.episodeProfileForm.descriptionLabel': 'Description',
  'podcasts.episodeProfileForm.descriptionPlaceholder': 'Short summary of when to use this profile',
  'podcasts.episodeProfileForm.speakerConfig.title': 'Speaker configuration',
  'podcasts.episodeProfileForm.speakerConfig.profileLabel': 'Speaker profile',
  'podcasts.episodeProfileForm.speakerConfig.profilePlaceholder': 'Select a speaker profile',
  'podcasts.episodeProfileForm.outline.title': 'Outline generation',
  'podcasts.episodeProfileForm.outline.providerLabel': 'Provider',
  'podcasts.episodeProfileForm.outline.providerPlaceholder': 'Select provider',
  'podcasts.episodeProfileForm.outline.modelLabel': 'Model',
  'podcasts.episodeProfileForm.outline.modelPlaceholder': 'Select model',
  'podcasts.episodeProfileForm.transcript.title': 'Transcript generation',
  'podcasts.episodeProfileForm.transcript.providerLabel': 'Provider',
  'podcasts.episodeProfileForm.transcript.providerPlaceholder': 'Select provider',
  'podcasts.episodeProfileForm.transcript.modelLabel': 'Model',
  'podcasts.episodeProfileForm.transcript.modelPlaceholder': 'Select model',
  'podcasts.episodeProfileForm.defaultBriefingLabel': 'Default briefing',
  'podcasts.episodeProfileForm.defaultBriefingPlaceholder': 'Outline the structure, tone, and goals for this episode format',
  'podcasts.episodeProfileForm.cancel': 'Cancel',
  'podcasts.episodeProfileForm.saving': 'Saving…',
  'podcasts.episodeProfileForm.creating': 'Creating…',
  'podcasts.episodeProfileForm.saveChanges': 'Save changes',
  'podcasts.episodeProfileForm.createProfile': 'Create profile',
  'podcasts.episodeProfileForm.errors.nameRequired': 'Name is required',
  'podcasts.episodeProfileForm.errors.speakerProfileRequired': 'Speaker profile is required',
  'podcasts.episodeProfileForm.errors.outlineProviderRequired': 'Outline provider is required',
  'podcasts.episodeProfileForm.errors.outlineModelRequired': 'Outline model is required',
  'podcasts.episodeProfileForm.errors.transcriptProviderRequired': 'Transcript provider is required',
  'podcasts.episodeProfileForm.errors.transcriptModelRequired': 'Transcript model is required',
  'podcasts.episodeProfileForm.errors.defaultBriefingRequired': 'Default briefing is required',
  'podcasts.episodeProfileForm.errors.segmentsInteger': 'Must be an integer',
  'podcasts.episodeProfileForm.errors.segmentsMin': 'At least 3 segments',
  'podcasts.episodeProfileForm.errors.segmentsMax': 'Maximum 20 segments',

  'podcasts.speakerProfileForm.editTitle': 'Edit Speaker Profile',
  'podcasts.speakerProfileForm.createTitle': 'Create Speaker Profile',
  'podcasts.speakerProfileForm.description': 'Configure text-to-speech settings and define up to four speakers.',
  'podcasts.speakerProfileForm.noModels.title': 'No text-to-speech models available',
  'podcasts.speakerProfileForm.noModels.description': 'Add TTS models in the Models section before creating a speaker profile.',
  'podcasts.speakerProfileForm.profileNameLabel': 'Profile name',
  'podcasts.speakerProfileForm.profileNamePlaceholder': 'Weekly show host',
  'podcasts.speakerProfileForm.providerLabel': 'Provider',
  'podcasts.speakerProfileForm.providerPlaceholder': 'Select provider',
  'podcasts.speakerProfileForm.modelLabel': 'Model',
  'podcasts.speakerProfileForm.modelPlaceholder': 'Select model',
  'podcasts.speakerProfileForm.descriptionLabel': 'Description',
  'podcasts.speakerProfileForm.descriptionPlaceholder': 'Notes about tone, brand, or usage',
  'podcasts.speakerProfileForm.speakers.title': 'Speakers',
  'podcasts.speakerProfileForm.speakers.description': 'Configure between one and four voices for this profile.',
  'podcasts.speakerProfileForm.speakers.add': 'Add speaker',
  'podcasts.speakerProfileForm.speakers.speaker': 'Speaker {index}',
  'podcasts.speakerProfileForm.speakers.remove': 'Remove',
  'podcasts.speakerProfileForm.speakers.nameLabel': 'Name',
  'podcasts.speakerProfileForm.speakers.namePlaceholder': 'Host 1',
  'podcasts.speakerProfileForm.speakers.voiceIdLabel': 'Voice ID',
  'podcasts.speakerProfileForm.speakers.voiceIdPlaceholder': 'voice_123',
  'podcasts.speakerProfileForm.speakers.backstoryLabel': 'Backstory',
  'podcasts.speakerProfileForm.speakers.backstoryPlaceholder': 'Short biography or context for the speaker',
  'podcasts.speakerProfileForm.speakers.personalityLabel': 'Personality',
  'podcasts.speakerProfileForm.speakers.personalityPlaceholder': 'Describe style and tone',
  'podcasts.speakerProfileForm.cancel': 'Cancel',
  'podcasts.speakerProfileForm.saving': 'Saving…',
  'podcasts.speakerProfileForm.creating': 'Creating…',
  'podcasts.speakerProfileForm.saveChanges': 'Save changes',
  'podcasts.speakerProfileForm.createProfile': 'Create profile',
  'podcasts.speakerProfileForm.errors.nameRequired': 'Name is required',
  'podcasts.speakerProfileForm.errors.voiceIdRequired': 'Voice ID is required',
  'podcasts.speakerProfileForm.errors.backstoryRequired': 'Backstory is required',
  'podcasts.speakerProfileForm.errors.personalityRequired': 'Personality is required',
  'podcasts.speakerProfileForm.errors.profileNameRequired': 'Name is required',
  'podcasts.speakerProfileForm.errors.providerRequired': 'Provider is required',
  'podcasts.speakerProfileForm.errors.modelRequired': 'Model is required',
  'podcasts.speakerProfileForm.errors.atLeastOneSpeaker': 'At least one speaker is required',
  'podcasts.speakerProfileForm.errors.maxFourSpeakers': 'You can configure up to 4 speakers',
}

const transformations = {
  'transformations.page.title': 'Transformations',
  'transformations.page.description': 'Transformations are prompts that will be used by the LLM to process a source and extract insights, summaries, etc.',
  'transformations.page.workspace_label': 'Choose a workspace',
  'transformations.page.tabs.transformations': 'Transformations',
  'transformations.page.tabs.playground': 'Playground',

  'transformations.card.default_badge': 'default',
  'transformations.card.playground_button': 'Playground',
  'transformations.card.edit_button': 'Edit',
  'transformations.card.title_label': 'Title',
  'transformations.card.untitled': 'Untitled',
  'transformations.card.description_label': 'Description',
  'transformations.card.prompt_label': 'Prompt',
  'transformations.card.delete_dialog.title': 'Delete Transformation',
  'transformations.card.delete_dialog.description': 'Are you sure you want to delete "{name}"? This action cannot be undone.',
  'transformations.card.delete_dialog.confirm_text': 'Delete',

  'transformations.default_prompt_editor.title': 'Default Transformation Prompt',
  'transformations.default_prompt_editor.description': 'This will be added to all your transformation prompts',
  'transformations.default_prompt_editor.placeholder': 'Enter your default transformation instructions...',
  'transformations.default_prompt_editor.save_button': 'Save',

  'transformations.list.empty_state.title': 'No transformations yet',
  'transformations.list.empty_state.description': 'Create your first transformation to process and extract insights from your content.',
  'transformations.list.empty_state.cta': 'Create New Transformation',
  'transformations.list.title': 'Your Transformations',
  'transformations.list.create_button': 'Create New Transformation',

  'transformations.playground.title': 'Playground',
  'transformations.playground.description': 'Test your transformations on sample text before applying them to your sources',
  'transformations.playground.transformation_label': 'Transformation',
  'transformations.playground.transformation_placeholder': 'Select a transformation',
  'transformations.playground.model_label': 'Model',
  'transformations.playground.model_placeholder': 'Select a model',
  'transformations.playground.input_label': 'Input Text',
  'transformations.playground.input_placeholder': 'Enter some text to transform...',
  'transformations.playground.running_button': 'Running...',
  'transformations.playground.run_button': 'Run Transformation',
  'transformations.playground.output_label': 'Output',

  'transformations.editor_dialog.errors.name_required': 'Name is required',
  'transformations.editor_dialog.errors.prompt_required': 'Prompt is required',
  'transformations.editor_dialog.title_edit': 'Edit transformation',
  'transformations.editor_dialog.title_create': 'Create transformation',
  'transformations.editor_dialog.loading': 'Loading transformation…',
  'transformations.editor_dialog.name_label': 'Name',
  'transformations.editor_dialog.name_placeholder': 'Unique identifier, e.g. key_topics',
  'transformations.editor_dialog.title_label': 'Title',
  'transformations.editor_dialog.title_placeholder': 'Displayed title, defaults to name',
  'transformations.editor_dialog.apply_default_label': 'Suggest by default on new sources',
  'transformations.editor_dialog.description_label': 'Description',
  'transformations.editor_dialog.description_placeholder': 'Describe what this transformation does.',
  'transformations.editor_dialog.prompt_label': 'Prompt',
  'transformations.editor_dialog.prompt_placeholder': 'Write the prompt that will power this transformation...',
  'transformations.editor_dialog.prompt_help_text': 'Prompts should be written with the source content in mind. You can ask the model to summarise, extract insights, or produce structured outputs such as tables.',
  'transformations.editor_dialog.cancel_button': 'Cancel',
  'transformations.editor_dialog.saving_button': 'Saving…',
  'transformations.editor_dialog.creating_button': 'Creating…',
  'transformations.editor_dialog.save_button': 'Save Transformation',
  'transformations.editor_dialog.create_button': 'Create Transformation',
}

const digitalEmployeesPage = {
  'digital_employees.title': 'Mobile Employees',
  'digital_employees.description': 'Manage your digital employees.',
  'digital_employees.view.table': 'Table',
  'digital_employees.view.cards': 'Cards',

  'digital_employees.table.empty': 'No digital employees',
  'digital_employees.table.select_all': 'Select all',
  'digital_employees.table.select_row': 'Select row',
  'digital_employees.table.serial': 'ID',
  'digital_employees.table.name': 'Name',
  'digital_employees.table.login': 'Login',
  'digital_employees.table.type': 'Type',
  'digital_employees.table.mode': 'Mode',
  'digital_employees.table.available': 'Available',
  'digital_employees.table.status': 'Status',
  'digital_employees.table.expired_at': 'Expires',
  'digital_employees.table.control': 'Controls',

  'digital_employees.type.1': 'RedBook KOL',
  'digital_employees.type.2': 'Video Account KOL',
  'digital_employees.type.3': 'TikTok KOL',
  'digital_employees.type.4': 'WeChat Add Friend',
  'digital_employees.type.5': 'Douyin KOL',
  'digital_employees.type.12': 'Mail Broadcast',
  'digital_employees.type.14': 'Boss Zhipin',
  'digital_employees.type.16': 'Qiwei Private',
  'digital_employees.type.17': 'Qianniu',
  'digital_employees.type.18': 'WeChat Official Phone',
  'digital_employees.type.19': 'RedBook Group Siphon',

  'digital_employees.status.init': 'Init',
  'digital_employees.status.op_too_frequent': 'Too frequent',
  'digital_employees.status.login': 'Logged in',
  'digital_employees.status.captcha': 'Captcha',
  'digital_employees.status.account_exception': 'Account exception',
  'digital_employees.status.exception': 'Device exception',
  'digital_employees.status.account_rest': 'Account rest',
  'digital_employees.status.task': 'Task in progress',
  'digital_employees.status.need_clear_data': 'Needs cleanup',
  'digital_employees.status.account_restricted': 'Account restricted',
  'digital_employees.status.unknown': 'Unknown',

  'digital_employees.login.yes': 'Logged in',
  'digital_employees.login.no': 'Not logged in',
  'digital_employees.available.yes': 'Available',
  'digital_employees.available.no': 'Unavailable',
  'digital_employees.mode.otg': 'OTG',
  'digital_employees.mode.usb': 'USB',

  'digital_employees.action.mirror': 'Mirror',
  'digital_employees.action.remove': 'Remove',

  'digital_employees.batch.selected': 'Selected {count} items',
  'digital_employees.batch.delete': 'Batch Delete',
  'digital_employees.batch.delete_confirm_title': 'Confirm batch delete?',
  'digital_employees.batch.delete_confirm_description': 'This will permanently delete {count} digital employees.',
  'digital_employees.refresh': 'Refresh',

  'digital_employees.filters.name_placeholder': 'Name',
  'digital_employees.filters.status_placeholder': 'Status',
  'digital_employees.filters.status_all': 'All statuses',
  'digital_employees.filters.type_placeholder': 'Business Type',
  'digital_employees.filters.type_all': 'All business types',


  'digital_employees.pagination.total': 'Total {count}',
  'digital_employees.pagination.page_size': 'Page size',
  'digital_employees.pagination.per_page': '{count} per page',
  'digital_employees.pagination.prev': 'Previous',
  'digital_employees.pagination.next': 'Next',
  'digital_employees.pagination.page': 'Page {page} / {total}',
  'digital_employees.add': 'Add digital employee',
  'digital_employees.dialog.title': 'Add digital employee',
  'digital_employees.dialog.title_edit': 'Update device',
  'digital_employees.dialog.description': 'Create a device-backed digital employee for your workspace.',
  'digital_employees.dialog.submit': 'Create',
  'digital_employees.dialog.submit_update': 'Update',
  'digital_employees.dialog.creating': 'Creating…',
  'digital_employees.dialog.updating': 'Updating…',
  'digital_employees.dialog.cancel': 'Cancel',
  'digital_employees.dialog.fields.serial_number': 'Serial number',
  'digital_employees.dialog.fields.area': 'Device area',
  'digital_employees.dialog.fields.area_placeholder': 'Select a device area',
  'digital_employees.dialog.fields.device_mode': 'Device mode',
  'digital_employees.dialog.fields.device_mode_otg': 'OTG',
  'digital_employees.dialog.fields.device_mode_usb': 'USB',
  'digital_employees.dialog.fields.forward_port': 'Forward port',
  'digital_employees.dialog.fields.remark': 'Remark',
  'digital_employees.dialog.fields.available': 'Available',
  'digital_employees.dialog.fields.available_on': 'Available',
  'digital_employees.dialog.fields.available_off': 'Unavailable',
  'digital_employees.dialog.fields.tags': 'Tags',
  'digital_employees.dialog.fields.tags_placeholder': 'Space-separated tags (e.g. test KOL)',
  'digital_employees.toast.create_success': 'Mobile employee created',
  'digital_employees.toast.update_success': 'Device updated',
  'digital_employees.toast.delete_success': 'Mobile employee removed',
  'digital_employees.toast.create_error': 'Could not create digital employee',
  'digital_employees.toast.update_error': 'Could not update device',
  'digital_employees.toast.delete_error': 'Could not remove digital employee',
  'digital_employees.delete_confirm_title': 'Confirm delete?',
  'digital_employees.delete_confirm_description': 'This will permanently delete {name} ({id}), this action cannot be undone.',
}

const marketplacePage = {
  'marketplace.title': 'App Store',
  'marketplace.description': 'Manage your apps.',
  'marketplace.searchPlaceholder': 'Search apps...',
  'marketplace.searchClear': 'Clear search',
  'marketplace.categoryPlaceholder': 'Category',
  'marketplace.category.all': 'All Categories',
  'marketplace.refresh': 'Refresh',
  'marketplace.retry': 'Retry',
  'marketplace.loadError.title': 'Failed to load apps',
  'marketplace.loadError.description': 'Please check your connection and try again.',
  'marketplace.empty.title': 'No apps found',
  'marketplace.empty.description': 'Try adjusting your search keywords or category filters.',
  'marketplace.premium': 'Premium Apps',
  'marketplace.viewDetail': 'View Details',
  'marketplace.download': 'Download',
  'marketplace.download.missing': 'Download not available for this app.',
  'marketplace.download.unsupported': 'Download not supported on current platform.',
  'marketplace.download.started': 'Download started',
  'marketplace.launch': 'Launch',
  'marketplace.login': 'Login',
  'marketplace.launch.toast': 'Launching: {name}',
  'marketplace.details.summary': 'Summary',
  'marketplace.details.features': 'Features',

  'marketplace.category.AIGC': 'AIGC',
  'marketplace.category.KOL': 'KOL Mining',
  'marketplace.category.Flow': 'Workflow',
  'marketplace.category.Shop': 'E-commerce Tools',
  'marketplace.category.Common': 'Common Tools',
  'marketplace.category.quntool': 'Private Domain Tools',

  'marketplace.plateType.AIGC': 'AIGC',
  'marketplace.plateType.KOL': 'KOL Mining',
  'marketplace.plateType.Flow': 'Workflow',
  'marketplace.plateType.Shop': 'E-commerce Tools',
  'marketplace.plateType.Common': 'Common Tools',
  'marketplace.plateType.quntool': 'Private Domain Tools',

  'marketplace.plate.1': 'Customer Acquisition',
  'marketplace.plate.2': 'Private Domain Operations',
}

const workflowsPage = {
  'workflows.title': 'Workflows',
  'workflows.description': 'Manage your workflows.',
  'workflows.toast.createGroupFailed': 'Failed to create group',
  'workflows.toast.updateGroupFailed': 'Failed to update group',
  'workflows.toast.emptyGroupSuccess': 'Group disbanded successfully',
  'workflows.toast.emptyGroupFailed': 'Failed to disband group',
  'workflows.toast.deleteGroupSuccess': 'Deleted successfully',
  'workflows.toast.deleteGroupFailed': 'Failed to delete group',
  'workflows.toast.createWorkflowFailed': 'Failed to create workflow',
  'workflows.toast.saveSuccess': 'Saved successfully',
  'workflows.toast.saveFailed': 'Failed to save',
  'workflows.toast.lockedSuccess': 'Locked successfully',
  'workflows.toast.unlockedSuccess': 'Unlocked successfully',
  'workflows.toast.operationFailed': 'Operation failed',
  'workflows.toast.copySuccess': 'Copied successfully',
  'workflows.toast.copyFailed': 'Failed to copy',
  'workflows.toast.deleteSuccess': 'Deleted successfully',
  'workflows.toast.deleteFailed': 'Failed to delete',
  'workflows.action.move': 'Move to Group',
  'workflows.group.default': 'Default Group',
  'workflows.toast.moveFailed': 'Failed to move',
}

const advancedPage = {
  'advanced.page.title': 'Advanced',
  'advanced.page.description': 'Tools and utilities for power users',

  'advanced.rebuild.title': 'Rebuild Vectors',
  'advanced.rebuild.description': 'Rebuild vectors for your content. Use this when switching embedding models or to fix corrupted vectors.',
  'advanced.rebuild.mode.label': 'Rebuild Mode',
  'advanced.rebuild.mode.existing.label': 'Existing Only',
  'advanced.rebuild.mode.all.label': 'All',
  'advanced.rebuild.mode.existing.description': 'Re-embed only items that already have vectors (faster, for model switching)',
  'advanced.rebuild.mode.all.description': 'Re-embed existing items + create vectors for items without them (slower, more comprehensive)',
  'advanced.rebuild.include.label': 'Rebuild Scope',
  'advanced.rebuild.include.sources': 'Sources',
  'advanced.rebuild.include.notes': 'Notes',
  'advanced.rebuild.include.insights': 'Insights',
  'advanced.rebuild.include.error': 'Please select at least one item type to rebuild',
  'advanced.rebuild.cta.loading': 'Starting rebuild...',
  'advanced.rebuild.cta.default': 'Start Rebuild',
  'advanced.rebuild.start_error': 'Failed to start rebuild: {message}',
  'advanced.rebuild.unknown_error': 'Unknown error',
  'advanced.rebuild.status.queued': 'Queued',
  'advanced.rebuild.status.running': 'Running...',
  'advanced.rebuild.status.completed': 'Completed!',
  'advanced.rebuild.status.failed': 'Failed',
  'advanced.rebuild.status.running_description': 'You can leave this page, the rebuild will run in the background',
  'advanced.rebuild.cta.new': 'Start New Rebuild',
  'advanced.rebuild.progress.label': 'Progress',
  'advanced.rebuild.progress.stats': '{processed}/{total} items ({percent}%)',
  'advanced.rebuild.progress.failed': '⚠️ {count} items failed',
  'advanced.rebuild.stats.time': 'Time',
  'advanced.rebuild.stats.started': 'Started',
  'advanced.rebuild.stats.completed': 'Completed',
  'advanced.rebuild.help.when.trigger': 'When should I rebuild vectors?',
  'advanced.rebuild.help.when.title': 'You should rebuild vectors when:',
  'advanced.rebuild.help.when.item1.title': 'Switching embedding models:',
  'advanced.rebuild.help.when.item1.description': 'If you switch from one embedding model to another, you need to rebuild all vectors to ensure consistency.',
  'advanced.rebuild.help.when.item2.title': 'Upgrading model versions:',
  'advanced.rebuild.help.when.item2.description': 'When updating to a new version of an embedding model, rebuild to take advantage of improvements.',
  'advanced.rebuild.help.when.item3.title': 'Fixing corrupted vectors:',
  'advanced.rebuild.help.when.item3.description': 'If you suspect some vectors are corrupted or missing, a rebuild can restore them.',
  'advanced.rebuild.help.when.item4.title': 'After bulk import:',
  'advanced.rebuild.help.when.item4.description': 'If you imported content without vectors, use "All" mode to embed everything.',
  'advanced.rebuild.help.time.trigger': 'How long does a rebuild take?',
  'advanced.rebuild.help.time.title': 'Processing time depends on:',
  'advanced.rebuild.help.time.item1': 'Number of items to process',
  'advanced.rebuild.help.time.item2': 'Embedding model speed',
  'advanced.rebuild.help.time.item3': 'API rate limits (for cloud providers)',
  'advanced.rebuild.help.time.item4': 'System resources',
  'advanced.rebuild.help.time.rates_title': 'Typical rates:',
  'advanced.rebuild.help.time.rate1.title': 'Local models',
  'advanced.rebuild.help.time.rate1.description': '(Ollama): Very fast, limited only by hardware',
  'advanced.rebuild.help.time.rate2.title': 'Cloud APIs',
  'advanced.rebuild.help.time.rate2.description': '(OpenAI, Google): Moderate speed, may hit rate limits with large datasets',
  'advanced.rebuild.help.time.rate3.title': 'Sources:',
  'advanced.rebuild.help.time.rate3.description': 'Slower than notes/insights (multiple chunks created per source)',
  'advanced.rebuild.help.time.example': 'Example: Rebuilding 200 items with Cloud API might take 2-5 minutes, less than 1 minute with local models.',
  'advanced.rebuild.help.safe.trigger': 'Is it safe to rebuild while using the app?',
  'advanced.rebuild.help.safe.title': 'Yes, rebuilding is safe!',
  'advanced.rebuild.help.safe.item1.title': 'Idempotent:',
  'advanced.rebuild.help.safe.item1.description': 'Running multiple times produces the same result',
  'advanced.rebuild.help.safe.item2.title': 'Non-destructive:',
  'advanced.rebuild.help.safe.item2.description': 'Only replaces vectors',
  'advanced.rebuild.help.safe.item3.title': 'Run anytime:',
  'advanced.rebuild.help.safe.item3.description': 'No need to stop other operations',
  'advanced.rebuild.help.safe.item4.title': 'Graceful error handling:',
  'advanced.rebuild.help.safe.item4.description': 'Failed items are logged and skipped',
  'advanced.rebuild.help.safe.warning.title': 'However:',
  'advanced.rebuild.help.safe.warning.description': 'Very large rebuilds (thousands of items) might temporarily slow down search during processing.',

  'advanced.system_info.title': 'System Info',
  'advanced.system_info.loading': 'Loading...',
  'advanced.system_info.current_version': 'Current Version',
  'advanced.system_info.unknown': 'Unknown',
  'advanced.system_info.latest_version': 'Latest Version',
  'advanced.system_info.status': 'Status',
  'advanced.system_info.update_available': 'Update Available',
  'advanced.system_info.up_to_date': 'Up to Date',
  'advanced.system_info.view_on_website': 'View on Website',
  'advanced.system_info.update_check_failed': 'Failed to check for updates. Update server may be unreachable.',

  'advanced.desktop_runtime.title': 'Desktop Runtime',
  'advanced.desktop_runtime.description': 'Manage local desktop backend and sidecar services',
  'advanced.desktop_runtime.backend': 'Backend Process',
  'advanced.desktop_runtime.runtime': 'Python Runtime',
  'advanced.desktop_runtime.sidecars': 'Sidecar Services',
  'advanced.desktop_runtime.healthy': 'Healthy',
  'advanced.desktop_runtime.unhealthy': 'Unhealthy',
  'advanced.desktop_runtime.not_configured': 'Not Configured',
  'advanced.desktop_runtime.pid': 'PID',
  'advanced.desktop_runtime.restart_backend': 'Restart Backend',
  'advanced.desktop_runtime.start_runtime': 'Start Runtime',
  'advanced.desktop_runtime.stop_runtime': 'Stop Runtime',
  'advanced.desktop_runtime.start_sidecars': 'Start Sidecars',
  'advanced.desktop_runtime.stop_sidecars': 'Stop Sidecars',
  'advanced.desktop_runtime.diagnostics': 'Diagnostics',
  'advanced.desktop_runtime.export_diagnostics': 'Export Diagnostics',
  'advanced.desktop_runtime.exported_path': 'Exported file',
  'advanced.desktop_runtime.total_errors': 'Total Errors',
  'advanced.desktop_runtime.fault.title': 'Startup Fault Detected',
  'advanced.desktop_runtime.recheck': 'Recheck',
  'advanced.desktop_runtime.error_code.BACKEND_START_FAILED': 'BACKEND_START_FAILED',
  'advanced.desktop_runtime.error_code.RUNTIME_START_FAILED': 'RUNTIME_START_FAILED',
  'advanced.desktop_runtime.error_code.SIDECAR_NOT_CONFIGURED': 'SIDECAR_NOT_CONFIGURED',
  'advanced.desktop_runtime.error_code.PORT_CONFLICT': 'PORT_CONFLICT',
  'advanced.desktop_runtime.error_code.UNKNOWN': 'UNKNOWN',
  'advanced.desktop_runtime.error_hint.port_conflict.1': 'A required local port may already be occupied by another process.',
  'advanced.desktop_runtime.error_hint.port_conflict.2': 'Stop conflicting processes or change desktop ports, then retry startup.',
  'advanced.desktop_runtime.error_hint.backend_failed.1': 'Desktop Python backend failed to start or exited early.',
  'advanced.desktop_runtime.error_hint.backend_failed.2': 'Check Python environment and rerun after exporting diagnostics.',
  'advanced.desktop_runtime.error_hint.runtime_failed.1': 'Runtime service startup did not reach healthy state in time.',
  'advanced.desktop_runtime.error_hint.runtime_failed.2': 'Check sidecar commands, logs and dependencies, then restart runtime.',
  'advanced.desktop_runtime.error_hint.sidecar_config.1': 'PostgreSQL/Redis sidecar startup commands are not configured.',
  'advanced.desktop_runtime.error_hint.sidecar_config.2': 'Set DESKTOP_POSTGRES_COMMAND / DESKTOP_REDIS_COMMAND in desktop env.',
  'advanced.desktop_runtime.error_hint.unknown.1': 'An unknown startup error was detected.',
  'advanced.desktop_runtime.error_hint.unknown.2': 'Export diagnostics and inspect runtime and service logs for details.',

  'advanced.jobs.title': 'Job Queue',
  'advanced.jobs.description': 'Monitor background tasks and jobs',
  'advanced.jobs.empty': 'No jobs',
  'advanced.jobs.columns.status': 'Status',
  'advanced.jobs.columns.type': 'Type',
  'advanced.jobs.columns.details': 'Details',
  'advanced.jobs.columns.created': 'Created',
  'advanced.jobs.columns.started': 'Started',
  'advanced.jobs.columns.duration': 'Duration',
  'advanced.jobs.total': 'Total: {count}',
  'advanced.jobs.columns.actions': 'Actions',
  'advanced.jobs.actions.retry': 'Retry',
  'advanced.jobs.status.new': 'New',
  'advanced.jobs.status.running': 'Running',
  'advanced.jobs.status.completed': 'Completed',
  'advanced.jobs.status.failed': 'Failed',
  'advanced.jobs.status.canceled': 'Canceled',
  'advanced.jobs.source_filter_placeholder': 'Filter by source',
  'advanced.jobs.all_sources': 'All Sources',
}

const sourceCard = {
  'sourceCard.status.new.label': 'New',
  'sourceCard.status.new.description': 'Source created',
  'sourceCard.status.queued.label': 'Queued',
  'sourceCard.status.queued.description': 'Waiting for processing',
  'sourceCard.status.running.label': 'Processing',
  'sourceCard.status.running.description': 'Processing content',
  'sourceCard.status.completed.label': 'Completed',
  'sourceCard.status.completed.description': 'Processing complete',
  'sourceCard.status.failed.label': 'Failed',
  'sourceCard.status.failed.description': 'Processing failed',
  'sourceCard.untitled': 'Untitled Source',
  'sourceCard.checking': 'Checking status...',
  'sourceCard.type.link': 'Link',
  'sourceCard.type.upload': 'File',
  'sourceCard.type.text': 'Text',
  'sourceCard.type.unknown': 'Unknown',
  'sourceCard.insights': '{count} insights',
  'sourceCard.moreTopics': '+{count} more',
  'sourceCard.actions.removeFromNotebook': 'Remove from Notebook',
  'sourceCard.actions.retry': 'Retry Processing',
  'sourceCard.actions.rebuildVectorFailed': 'Rebuild Failed Vector Tasks',
  'sourceCard.actions.rebuildGraphFailed': 'Rebuild Failed Graph Tasks',
  'sourceCard.actions.delete': 'Delete Source',
  'sourceCard.rebuild.vector.loading': 'Rebuilding vectors...',
  'sourceCard.rebuild.vector.success': 'Vector tasks queued for rebuild',
  'sourceCard.rebuild.vector.error': 'Failed to rebuild vector tasks',
  'sourceCard.rebuild.graph.loading': 'Rebuilding graph...',
  'sourceCard.rebuild.graph.success': 'Graph tasks queued for rebuild',
  'sourceCard.rebuild.graph.error': 'Failed to rebuild graph tasks',
  'sourceCard.progress': 'Processing Progress',
  'sourceCard.embed': 'Embed',
  'sourceCard.graphrag': 'Graph',
  'sourceCard.graphragProgress': 'Graph Progress',
}

const sourceDetail = {
  'sourceDetail.error.load': 'Failed to load source details',
  'sourceDetail.error.selectTransformation': 'Please select a transformation',
  'sourceDetail.success.insightCreated': 'Insight created successfully',
  'sourceDetail.error.createInsight': 'Failed to create insight',
  'sourceDetail.success.titleUpdated': 'Source title updated',
  'sourceDetail.error.updateTitle': 'Failed to update source title',
  'sourceDetail.error.embed': 'Failed to embed content',
  'sourceDetail.success.downloadStarted': 'Download started',
  'sourceDetail.error.fileUnavailable': 'Original file is no longer available on server',
  'sourceDetail.error.download': 'Failed to download file',
  'sourceDetail.success.urlCopied': 'URL copied to clipboard',
  'sourceDetail.confirm.delete': 'Are you sure you want to delete this source?',
  'sourceDetail.success.delete': 'Source deleted successfully',
  'sourceDetail.error.delete': 'Failed to delete source',
  'sourceDetail.notFound': 'Source not found',
  'sourceDetail.title.placeholder': 'Source Title',
  'sourceDetail.title.untitled': 'Untitled Source',
  'sourceDetail.sourceId': 'Source ID: {id}',
  'sourceDetail.chat': 'Chat with Source',
  'sourceDetail.file.unavailable': 'File Unavailable',
  'sourceDetail.file.preparing': 'Preparing download...',
  'sourceDetail.file.download': 'Download File',
  'sourceDetail.embed.embedding': 'Embedding...',
  'sourceDetail.embed.alreadyEmbedded': 'Embedded',
  'sourceDetail.embed.action': 'Embed Content',
  'sourceDetail.delete': 'Delete Source',
  'sourceDetail.tabs.content': 'Content',
  'sourceDetail.tabs.insights': 'Insights',
  'sourceDetail.tabs.details': 'Details',
  'sourceDetail.youtube.open': 'Open on YouTube',
  'sourceDetail.content.empty': 'No content',
  'sourceDetail.insights.description': 'AI-generated insights about this source',
  'sourceDetail.insights.generate': 'Generate New Insight',
  'sourceDetail.insights.selectTransformation': 'Select a transformation...',
  'sourceDetail.insights.creating': 'Creating...',
  'sourceDetail.insights.create': 'Create',
  'sourceDetail.insights.empty.title': 'No insights yet',
  'sourceDetail.insights.empty.description': 'Create your first insight using a transformation above',
  'sourceDetail.insights.view': 'View Insight',
  'sourceDetail.insights.confirmDeleteTitle': 'Delete this insight?',
  'sourceDetail.insights.confirmDeleteDescription': 'This action cannot be undone.',
  'sourceDetail.alert.notEmbedded.title': 'Content Not Embedded',
  'sourceDetail.alert.notEmbedded.description': 'This content has not been embedded for vector search. Embedding enables advanced search capabilities and better content discovery.',
  'sourceDetail.alert.graphNotBuilt.title': 'Knowledge Graph Not Built',
  'sourceDetail.alert.graphNotBuilt.description': 'This content has not been processed for knowledge graph (GraphRAG). Building the graph enables deeper entity relationship analysis and complex Q&A.',
  'sourceDetail.graphrag.building': 'Building...',
  'sourceDetail.graphrag.alreadyBuilt': 'Graph Built',
  'sourceDetail.graphrag.action': 'Build Knowledge Graph',
  'sourceDetail.graphrag.progress': 'Graph Build Progress',
  'sourceDetail.graphrag.failed': '{count} failed tasks',
  'sourceDetail.error.buildGraph': 'Failed to build knowledge graph',
  'sourceDetail.url': 'URL',
  'sourceDetail.uploadedFile': 'Uploaded File',
  'sourceDetail.file.unavailableButton': 'Unavailable',
  'sourceDetail.file.preparingButton': 'Preparing...',
  'sourceDetail.file.downloadButton': 'Download',
  'sourceDetail.file.unavailableDescription': 'The original file is no longer available on the server (likely deleted after processing). Upload again if you need a fresh copy.',
  'sourceDetail.topics': 'Topics',
  'sourceDetail.metadata': 'Metadata',
  'sourceDetail.metadata.embedded': 'Embedded',
  'sourceDetail.metadata.notEmbedded': 'Not Embedded',
  'sourceDetail.metadata.graphBuilt': 'Graph Built',
  'sourceDetail.metadata.graphNotBuilt': 'Graph Not Built',
  'sourceDetail.metadata.entityCount': '{count} entities',
  'sourceDetail.metadata.created': 'Created',
  'sourceDetail.metadata.updated': 'Updated',
  'sourceDetail.type.unknown': 'Unknown',
  'sourceDetail.type.link': 'Link',
  'sourceDetail.type.file': 'File',
  'sourceDetail.type.text': 'Text',
}

const streamingResponse = {
  'streamingResponse.error.notFound': 'This {type} could not be found',
  'streamingResponse.ariaLabel': 'Ask response',
  'streamingResponse.strategy.title': 'Strategy',
  'streamingResponse.strategy.reasoning': 'Reasoning:',
  'streamingResponse.strategy.searchTerms': 'Search Terms:',
  'streamingResponse.individualAnswers': 'Individual Answers ({count})',
  'streamingResponse.finalAnswer': 'Final Answer',
  'streamingResponse.processing': 'Processing your question...',
}

const advancedModelsDialog = {
  'advancedModelsDialog.title': 'Advanced Model Selection',
  'advancedModelsDialog.description': 'Select specific models for each stage of the asking process',
  'advancedModelsDialog.strategyModel.label': 'Strategy Model',
  'advancedModelsDialog.strategyModel.placeholder': 'Select strategy model',
  'advancedModelsDialog.answerModel.label': 'Answer Model',
  'advancedModelsDialog.answerModel.placeholder': 'Select answer model',
  'advancedModelsDialog.finalAnswerModel.label': 'Final Answer Model',
  'advancedModelsDialog.finalAnswerModel.placeholder': 'Select final answer model',
  'advancedModelsDialog.cancel': 'Cancel',
  'advancedModelsDialog.save': 'Save Changes',
}

const saveToNotebooksDialog = {
  'saveToNotebooksDialog.title': 'Save to Notebooks',
  'saveToNotebooksDialog.description': 'Select one or more notebooks to save this answer',
  'saveToNotebooksDialog.error.selectNotebook': 'Please select at least one notebook',
  'saveToNotebooksDialog.success.saved': 'Answer saved to {count} notebooks',
  'saveToNotebooksDialog.error.saveFailed': 'Failed to save answer',
  'saveToNotebooksDialog.empty': 'No notebooks found. Please create a notebook first.',
  'saveToNotebooksDialog.cancel': 'Cancel',
  'saveToNotebooksDialog.saving': 'Saving...',
  'saveToNotebooksDialog.save': 'Save to {count} Notebooks',
}

const modelsToast = {
  'models.toast.create.success.title': 'Success',
  'models.toast.create.success.description': 'Model created successfully',
  'models.toast.create.success.description_with_dim': 'Model created successfully (Detected vector dimension: {dim})',
  'models.toast.create.error.title': 'Error',
  'models.toast.create.error.description': 'Failed to create model',
  'models.toast.delete.success.title': 'Success',
  'models.toast.delete.success.description': 'Model deleted successfully',
  'models.toast.delete.error.title': 'Error',
  'models.toast.delete.error.description': 'Failed to delete model',
  'models.toast.updateDefaults.success.title': 'Success',
  'models.toast.updateDefaults.success.description': 'Default models updated successfully',
  'models.toast.updateDefaults.error.title': 'Error',
  'models.toast.updateDefaults.error.description': 'Failed to update default models',
  'models.toast.updateProviderSettings.success.title': 'Success',
  'models.toast.updateProviderSettings.success.description': 'Provider settings updated successfully',
  'models.toast.updateProviderSettings.error.title': 'Error',
  'models.toast.updateProviderSettings.error.description': 'Failed to update provider settings',
}

const xhsqunToast = {
  'xhsqun.autojoin.toast.selectWorkflow': 'Please select a workflow',
  'xhsqun.autojoin.toast.invalidDailyJoinLimit': 'Initial daily join limit cannot be greater than or equal to the final limit',
  'xhsqun.autojoin.toast.saveFailed': 'Failed to save',
  'xhsqun.autojoin.toast.selectDeviceGroup': 'Please select a device group',
  'xhsqun.autojoin.toast.saveSuccess': 'Saved successfully',
  'xhsqun.autojoin.toast.operationFailed': 'Operation failed',
  'xhsqun.autojoin.toast.deviceIdCopied': 'Device ID copied',
  'xhsqun.autojoin.toast.copyFailed': 'Copy failed',
  'xhsqun.autojoin.toast.invalidGroupSizeLimit': 'Group size lower limit cannot be greater than or equal to the upper limit',
  'xhsqun.autojoin.toast.stopSuccess': 'Task stopped successfully',
  'xhsqun.autojoin.toast.startSuccess': 'Task started successfully',
  'xhsqun.autojoin.toast.loadFailed': 'Failed to load',
  'xhsqun.autojoin.toast.operationSuccess': 'Operation successful',
}

const dykolToast = {
  'dykol.deviceGroups.toast.createSuccess': 'Created successfully',
  'dykol.deviceGroups.toast.createFailed': 'Failed to create',
  'dykol.deviceGroups.toast.updateSuccess': 'Updated successfully',
  'dykol.deviceGroups.toast.updateFailed': 'Failed to update',
  'dykol.deviceGroups.toast.deleteSuccess': 'Deleted successfully',
  'dykol.deviceGroups.toast.deleteFailed': 'Failed to delete',
  'dykol.deviceGroups.toast.enterGroupName': 'Please enter group name',
  'dykol.task.toast.createSuccess': 'Task created successfully',
  'dykol.task.toast.createFailed': 'Failed to create task',
}

const xhsqunPrivateToast = {
  'xhsqun.private.toast.saveSuccess': 'Saved successfully',
  'xhsqun.private.toast.saveFailed': 'Failed to save',
  'xhsqun.private.toast.selectWorkflow': 'Please select a workflow',
  'xhsqun.private.toast.loadFailed': 'Failed to load',
  'xhsqun.private.toast.operationFailed': 'Operation failed',
  'xhsqun.private.toast.paused': 'Paused',
  'xhsqun.private.toast.resumed': 'Resumed',
  'xhsqun.private.toast.deviceIdCopied': 'Device ID copied',
  'xhsqun.private.toast.copyFailed': 'Copy failed',
}

const emailTemplateToast = {
  'email.template.toast.deleteSuccess': 'Deleted successfully',
  'email.template.toast.deleteFailed': 'Failed to delete',
  'email.template.toast.createHint': 'Template creation page not yet migrated, please create in the old system.',
  'email.template.toast.editHint': 'Template edit page not yet migrated, please edit in the old system.',
}

const emailRenewToast = {
  'email.renew.toast.purchaseSuccess': 'Purchase successful',
  'email.renew.toast.purchaseFailed': 'Purchase failed',
  'email.renew.toast.statusUpdateSuccess': 'Status updated successfully',
  'email.renew.toast.statusUpdateFailed': 'Failed to update status',
  'email.renew.toast.enterSearchKeyword': 'Please enter search keyword',
  'email.renew.toast.searchFailed': 'Search failed',
  'email.renew.toast.selectDomain': 'Please select a domain to purchase',
  'email.renew.toast.rechargeHint': 'Recharge portal not yet migrated, please go to the old system.',
  'email.renew.toast.enterPurchaseQuantity': 'Purchase quantity cannot be empty',
}

const gnkeyToast = {
  'gnkey.page.toast.loadFailed': 'Failed to load',
  'gnkey.page.toast.deleteSuccess': 'Deleted successfully',
  'gnkey.page.toast.deleteFailed': 'Failed to delete',
  'gnkey.create.toast.openSuccess': 'Opened successfully',
  'gnkey.create.toast.openFailed': 'Failed to open',
  'gnkey.create.toast.noSceneId': 'No sceneId returned',
}

const emailCustomerToast = {
  'email.customer.toast.addSuccess': 'Added successfully',
  'email.customer.toast.addFailed': 'Failed to add',
  'email.customer.toast.updateSuccess': 'Updated successfully',
  'email.customer.toast.updateFailed': 'Failed to update',
  'email.customer.toast.deleteSuccess': 'Deleted successfully',
  'email.customer.toast.deleteFailed': 'Failed to delete',
  'email.customer.toast.cleanSuccess': 'Email cleaning successful',
  'email.customer.toast.cleanFailed': 'Email cleaning failed',
  'email.customer.toast.importSuccess': 'Import successful',
  'email.customer.toast.importFailed': 'Import failed',
  'email.customer.toast.enterName': 'Please enter name',
  'email.customer.toast.selectFile': 'Please select a file to upload',
  'email.customer.toast.noEmailsToClean': 'No emails to clean in the current form.',
  'email.customer.toast.insufficientQuota': 'Insufficient cleaning quota, please purchase in renewal management.',
  'email.customer.toast.createTaskHint': 'Task creation page not yet migrated, please create in the old system.',
}

const emailTaskToast = {
  'email.task.toast.info': 'Info',
  'email.task.toast.updateFailed': 'Update failed',
  'email.task.toast.deleteSuccess': 'Deleted successfully',
  'email.task.toast.deleteFailed': 'Failed to delete',
  'email.task.toast.createHint': 'Task creation page not yet migrated, please create in the old system.',
  'email.task.toast.detailHint': 'Task detail page not yet migrated, please view in the old system.',
  'email.task.toast.editHint': 'Task edit page not yet migrated, please edit in the old system.',
}

const workflowsToast = {
  'workflows.toast.createGroupFailed': 'Failed to create group',
  'workflows.toast.updateGroupFailed': 'Failed to update group',
  'workflows.toast.emptyGroupSuccess': 'Group disbanded successfully',
  'workflows.toast.emptyGroupFailed': 'Failed to disband group',
  'workflows.toast.deleteGroupSuccess': 'Deleted successfully',
  'workflows.toast.deleteGroupFailed': 'Failed to delete group',
  'workflows.toast.createWorkflowFailed': 'Failed to create workflow',
  'workflows.toast.saveSuccess': 'Saved successfully',
  'workflows.toast.saveFailed': 'Failed to save',
  'workflows.toast.lockedSuccess': 'Locked successfully',
  'workflows.toast.unlockedSuccess': 'Unlocked successfully',
  'workflows.toast.operationFailed': 'Operation failed',
  'workflows.toast.copySuccess': 'Copied successfully',
  'workflows.toast.copyFailed': 'Failed to copy',
  'workflows.toast.deleteSuccess': 'Deleted successfully',
  'workflows.toast.deleteFailed': 'Failed to delete',
  'workflows.action.move': 'Move to Group',
  'workflows.group.default': 'Default Group',
  'workflows.toast.moveFailed': 'Failed to move',
}

const gzhkolMonitorToast = {
  'gzhkol.monitor.toast.loadFailed': 'Failed to load',
  'gzhkol.monitor.toast.operationSuccess': 'Operation successful',
  'gzhkol.monitor.toast.operationFailed': 'Operation failed',
}

const gzhkolResourceToast = {
  'gzhkol.resource.toast.operationSuccess': 'Operation successful',
  'gzhkol.resource.toast.operationFailed': 'Operation failed',
  'gzhkol.resource.toast.updateSuccess': 'Updated successfully',
  'gzhkol.resource.toast.updateFailed': 'Failed to update',
  'gzhkol.resource.checkLink.toast.loadFailed': 'Failed to load',
}

const dykolTask = {
  'dykol.task.status.pending': 'Pending',
  'dykol.task.status.running': 'Running...',
  'dykol.task.status.completed': 'Completed',
  'dykol.task.status.paused': 'Paused',
  'dykol.task.time.justNow': 'Just now',
  'dykol.task.time.minutesAgo': '{minutes} mins ago',
  'dykol.task.time.minutesLater': '{minutes} mins later',
  'dykol.task.time.hoursAgo': '{hours} hours ago',
  'dykol.task.time.hoursLater': '{hours} hours later',
  'dykol.task.time.daysAgo': '{days} days ago',
  'dykol.task.time.daysLater': '{days} days later',
  'dykol.task.create.title': 'Create Task',
  'dykol.task.create.wizard': 'Task Wizard',
  'dykol.task.statistic.title': 'Task Statistics',
  'dykol.task.statistic.totalMatched': 'Total Matched',
  'dykol.task.statistic.todayMatched': 'Today Matched',
  'dykol.task.statistic.lastUpdated': 'Last Updated',
  'dykol.task.statistic.matchRate': 'Match Rate',
  'dykol.task.unit.person': 'people',
  'dykol.task.list.title': 'Mining Tasks',
  'dykol.task.list.count': 'Total Tasks {count}',
  'dykol.task.search.placeholder': 'Search task name',
  'dykol.task.filter.status': 'Status',
  'dykol.task.filter.all': 'All Status',
  'dykol.task.filter.pending': 'Pending',
  'dykol.task.filter.running': 'Running',
  'dykol.task.filter.completed': 'Completed',
  'dykol.task.filter.paused': 'Paused',
  'dykol.task.filter.clear': 'Clear',
  'dykol.task.list.loading': 'Loading...',
  'dykol.task.list.empty': 'No tasks',
  'dykol.task.list.loadingMore': 'Loading more...',
  'dykol.task.list.noMore': 'No more tasks',
  'dykol.task.toast.loadFailed': 'Load failed',
  'dykol.task.toast.deleteSuccess': 'Delete success',
  'dykol.task.toast.pauseSuccess': 'Pause success',
  'dykol.task.toast.resumeSuccess': 'Resume success',
  'dykol.task.toast.operationFailed': 'Operation failed',
  'dykol.task.action.delete': 'Delete',
  'dykol.task.action.pause': 'Pause',
  'dykol.task.action.resume': 'Resume',
  'dykol.task.confirm.deleteDescription': 'Cannot be recovered after deletion.',
  'dykol.task.confirm.actionDescription': 'Are you sure to {action} this task?',
  'dykol.task.card.status': 'Status: {status}',
  'dykol.task.card.devices': 'Using {count} devices',
  'dykol.task.card.lastMatched': 'Last matched: {time}',
  'dykol.task.card.actions': 'Actions',
  'dykol.task.card.resumeTask': 'Resume Task',
  'dykol.task.card.pauseTask': 'Pause Task',
  'dykol.task.card.deleteTask': 'Delete Task',
  'dykol.task.card.progress': 'Progress',
  'dykol.task.card.matchedCount': 'Matched',
  'dykol.task.card.collectedCount': 'Collected',
  'dykol.task.confirm.title': 'Confirm {action}',
}

const notebooksToast = {
  'notebooks.toast.create.success.title': 'Success',
  'notebooks.toast.create.success.description': 'Notebook created successfully',
  'notebooks.toast.create.error.title': 'Error',
  'notebooks.toast.create.error.description': 'Failed to create notebook',
  'notebooks.toast.update.success.title': 'Success',
  'notebooks.toast.update.success.description': 'Notebook updated successfully',
  'notebooks.toast.update.error.title': 'Error',
  'notebooks.toast.update.error.description': 'Failed to update notebook',
  'notebooks.toast.delete.success.title': 'Success',
  'notebooks.toast.delete.success.description': 'Notebook deleted successfully',
  'notebooks.toast.delete.error.title': 'Error',
  'notebooks.toast.delete.error.description': 'Failed to delete notebook',
}

const emailTaskPage = {
  'email.task.stats.totalSend': 'Total Send',
  'email.task.stats.todaySend': 'Today Send',
  'email.task.stats.todaySuccess': 'Today Reach',
  'email.task.stats.totalClick': 'Today Click',
  'email.task.stats.unit': 'people',
  'email.task.create.title': 'Create Task',
  'email.task.create.button': 'Create Task Now',
  'email.task.create.toast.title': 'Hint',
  'email.task.stats.title': 'Task Statistics',
  'email.task.list.title': 'Task List',
  'email.task.list.total': 'Total {count}',
  'email.task.filter.status.placeholder': 'Task Status',
  'email.task.filter.status.all': 'All Status',
  'email.task.filter.search.placeholder': 'Search task name',
  'email.task.filter.clear': 'Clear',
  'email.task.list.loading': 'Loading...',
  'email.task.list.empty': 'No tasks',
  'email.task.list.header.name': 'Task Name',
  'email.task.list.header.status': 'Status',
  'email.task.list.header.totalEmail': 'Total Emails',
  'email.task.list.header.cleanRate': 'Clean Rate',
  'email.task.list.header.sendProgress': 'Send Progress',
  'email.task.list.header.metrics': 'Reach/Read/Click',
  'email.task.list.header.createdAt': 'Created At',
  'email.task.list.header.actions': 'Actions',
  'email.task.metrics.reach': 'Reach',
  'email.task.metrics.read': 'Read',
  'email.task.metrics.click': 'Click',
  'email.task.delete.title': 'Delete Task',
  'email.task.delete.description': 'Task "{name}" cannot be recovered after deletion. Please proceed with caution.',
  'email.task.delete.confirm': 'Delete',
}

const notesToast = {
  'notes.toast.create.success.title': 'Success',
  'notes.toast.create.success.description': 'Note created successfully',
  'notes.toast.create.error.title': 'Error',
  'notes.toast.create.error.description': 'Failed to create note',
  'notes.toast.update.success.title': 'Success',
  'notes.toast.update.success.description': 'Note updated successfully',
  'notes.toast.update.error.title': 'Error',
  'notes.toast.update.error.description': 'Failed to update note',
  'notes.toast.delete.success.title': 'Success',
  'notes.toast.delete.success.description': 'Note deleted successfully',
  'notes.toast.delete.error.title': 'Error',
  'notes.toast.delete.error.description': 'Failed to delete note',
}

const podcastsToast = {
  'podcasts.toast.deleteEpisode.success.title': 'Episode deleted',
  'podcasts.toast.deleteEpisode.success.description': 'Podcast episode removed successfully.',
  'podcasts.toast.deleteEpisode.error.title': 'Failed to delete episode',
  'podcasts.toast.deleteEpisode.error.description': 'Please try again or check the server logs for details.',
  'podcasts.toast.createProfile.success.title': 'Episode profile created',
  'podcasts.toast.createProfile.success.description': 'The new episode profile is ready to use.',
  'podcasts.toast.createProfile.error.title': 'Failed to create episode profile',
  'podcasts.toast.createProfile.error.description': 'Double-check the form and try again.',
  'podcasts.toast.updateProfile.success.title': 'Episode profile updated',
  'podcasts.toast.updateProfile.success.description': 'Changes saved successfully.',
  'podcasts.toast.updateProfile.error.title': 'Failed to update episode profile',
  'podcasts.toast.updateProfile.error.description': 'Please try again later.',
  'podcasts.toast.deleteProfile.success.title': 'Episode profile deleted',
  'podcasts.toast.deleteProfile.success.description': 'Profile removed successfully.',
  'podcasts.toast.deleteProfile.error.title': 'Failed to delete episode profile',
  'podcasts.toast.deleteProfile.error.description': 'Ensure the profile is not in use and try again.',
  'podcasts.toast.duplicateProfile.success.title': 'Episode profile duplicated',
  'podcasts.toast.duplicateProfile.success.description': 'A copy of the profile has been created.',
  'podcasts.toast.duplicateProfile.error.title': 'Failed to duplicate episode profile',
  'podcasts.toast.duplicateProfile.error.description': 'Please try again later.',
  'podcasts.toast.createSpeaker.success.title': 'Speaker profile created',
  'podcasts.toast.createSpeaker.success.description': 'The speaker profile is ready to use.',
  'podcasts.toast.createSpeaker.error.title': 'Failed to create speaker profile',
  'podcasts.toast.createSpeaker.error.description': 'Double-check the form and try again.',
  'podcasts.toast.updateSpeaker.success.title': 'Speaker profile updated',
  'podcasts.toast.updateSpeaker.success.description': 'Changes saved successfully.',
  'podcasts.toast.updateSpeaker.error.title': 'Failed to update speaker profile',
  'podcasts.toast.updateSpeaker.error.description': 'Please try again later.',
  'podcasts.toast.deleteSpeaker.success.title': 'Speaker profile deleted',
  'podcasts.toast.deleteSpeaker.success.description': 'Profile removed successfully.',
  'podcasts.toast.deleteSpeaker.error.title': 'Failed to delete speaker profile',
  'podcasts.toast.deleteSpeaker.error.description': 'Ensure the profile is not in use and try again.',
  'podcasts.toast.duplicateSpeaker.success.title': 'Speaker profile duplicated',
  'podcasts.toast.duplicateSpeaker.success.description': 'A copy of the profile has been created.',
  'podcasts.toast.duplicateSpeaker.error.title': 'Failed to duplicate speaker profile',
  'podcasts.toast.duplicateSpeaker.error.description': 'Please try again later.',
  'podcasts.toast.generate.success.title': 'Podcast generation started',
  'podcasts.toast.generate.success.description': 'Episode "{name}" is being created.',
  'podcasts.toast.generate.error.title': 'Failed to start podcast generation',
  'podcasts.toast.generate.error.description': 'Please try again in a moment.',
}

const searchToast = {
  'search.toast.error.title': 'Search failed',
  'search.toast.error.description': 'An error occurred while searching',
}

const settingsToast = {
  'settings.toast.update.success.title': 'Success',
  'settings.toast.update.success.description': 'Settings updated successfully',
  'settings.toast.update.error.title': 'Error',
  'settings.toast.update.error.description': 'Failed to update settings',
}

const sourcesToast = {
  'sources.toast.create.queued.title': 'Source Queued',
  'sources.toast.create.queued.description': 'Source submitted for background processing. You can monitor progress in the sources list.',
  'sources.toast.create.success.title': 'Success',
  'sources.toast.create.success.description': 'Source added successfully',
  'sources.toast.create.error.title': 'Error',
  'sources.toast.create.error.description': 'Failed to add source',
  'sources.toast.update.success.title': 'Success',
  'sources.toast.update.success.description': 'Source updated successfully',
  'sources.toast.update.error.title': 'Error',
  'sources.toast.update.error.description': 'Failed to update source',
  'sources.toast.delete.success.title': 'Success',
  'sources.toast.delete.success.description': 'Source deleted successfully',
  'sources.toast.delete.error.title': 'Error',
  'sources.toast.delete.error.description': 'Failed to delete source',
  'sources.toast.upload.success.title': 'Success',
  'sources.toast.upload.success.description': 'File uploaded successfully',
  'sources.toast.upload.error.title': 'Error',
  'sources.toast.upload.error.description': 'Failed to upload file',
  'sources.toast.retry.success.title': 'Source Retry Queued',
  'sources.toast.retry.success.description': 'The source has been requeued for processing.',
  'sources.toast.retry.error.title': 'Retry Failed',
  'sources.toast.retry.error.description': 'Failed to retry source processing. Please try again.',
  'sources.toast.addToNotebook.success.title': 'Success',
  'sources.toast.addToNotebook.success.description': '{count} {count, plural, one {source} other {sources}} added to notebook',
  'sources.toast.addToNotebook.error.title': 'Error',
  'sources.toast.addToNotebook.error.description': 'Failed to add sources to notebook',
  'sources.toast.addToNotebook.partial.title': 'Partial Success',
  'sources.toast.addToNotebook.partial.description': '{successes} {successes, plural, one {source} other {sources}} added, {failures} failed',
  'sources.toast.removeFromNotebook.success.title': 'Success',
  'sources.toast.removeFromNotebook.success.description': 'Source removed from notebook successfully',
  'sources.toast.removeFromNotebook.error.title': 'Error',
  'sources.toast.removeFromNotebook.error.description': 'Failed to remove source from notebook',
}

const transformationsToast = {
  'transformations.toast.create.success.title': 'Success',
  'transformations.toast.create.success.description': 'Transformation created successfully',
  'transformations.toast.create.error.title': 'Error',
  'transformations.toast.create.error.description': 'Failed to create transformation',
  'transformations.toast.update.success.title': 'Success',
  'transformations.toast.update.success.description': "Transformation '{name}' saved successfully",
  'transformations.toast.update.error.title': 'Error',
  'transformations.toast.update.error.description': 'Failed to update transformation',
  'transformations.toast.delete.success.title': 'Success',
  'transformations.toast.delete.success.description': 'Transformation deleted successfully',
  'transformations.toast.delete.error.title': 'Error',
  'transformations.toast.delete.error.description': 'Failed to delete transformation',
  'transformations.toast.execute.error.title': 'Error',
  'transformations.toast.execute.error.description': 'Failed to execute transformation',
  'transformations.toast.updateDefaultPrompt.success.title': 'Success',
  'transformations.toast.updateDefaultPrompt.success.description': 'Default prompt saved successfully',
  'transformations.toast.updateDefaultPrompt.error.title': 'Error',
  'transformations.toast.updateDefaultPrompt.error.description': 'Failed to update default prompt',
}

const versionCheckToast = {
  'versionCheck.toast.available.title': 'Version {version} available',
  'versionCheck.toast.available.description': 'A new version of FishOwn Agent is available.',
  'versionCheck.toast.available.action': 'View on GitHub',
}

const chatToast = {
  'chat.toast.createSession.success': 'Chat session created',
  'chat.toast.createSession.error': 'Failed to create chat session',
  'chat.toast.updateSession.success': 'Session updated',
  'chat.toast.updateSession.error': 'Failed to update session',
  'chat.toast.deleteSession.success': 'Session deleted',
  'chat.toast.deleteSession.error': 'Failed to delete session',
  'chat.toast.sendMessage.error': 'Failed to send message',
}

const commonToast = {
  'common.toast.error': 'Error',
  'common.toast.success': 'Success',
}

const skillsPage = {
  'skills.title': 'Skills',
  'skills.subtitle': 'Built-in, hosted, and workspace skills.',
  'skills.filter': 'Filter',
  'skills.searchPlaceholder': 'Search skills',
  'skills.showing': 'Showing {count} items',
  'skills.refresh': 'Refresh',
  'skills.loadError.title': 'Failed to load skills',
  'skills.loadError.description': 'An error occurred while retrieving the skills list from the server.',
  'skills.retry': 'Retry',
  'skills.empty.title': 'No skills found.',
  'skills.empty.description': 'Please check your configuration or try again later.',
  'skills.empty.search': 'No matching skills found.',
  'skills.source.bundled': 'Bundled',
  'skills.source.hosted': 'Hosted',
  'skills.source.workspace': 'Workspace',
  'skills.actions.enable': 'Enable',
  'skills.actions.disable': 'Disable',
  'skills.card.noDescription': 'No description',
  'skills.browseStore': 'Browse Skills Store',
  'skills.groups.workspace': 'Workspace Skills',
  'skills.groups.builtIn': 'Built-in Skills',
  'skills.groups.installed': 'Installed Skills',
  'skills.groups.extra': 'Extra Skills',
  'skills.groups.other': 'Other Skills',
  'skills.status.bundled': 'bundled',
  'skills.status.eligible': 'eligible',
  'skills.status.blocked': 'blocked',
  'skills.status.disabled': 'disabled',
  'skills.card.missing': 'Missing: {reasons}',
  'skills.card.reason': 'Reason: {reasons}',
  'skills.actions.saveKey': 'Save key',
  'skills.apiKey': 'API key',
  'skills.installing': 'Installing…',
}

const cronPage = {
  'cron.title': 'Cron Jobs',
  'cron.subtitle': 'Manage automated and scheduled tasks for your agents.',
  'cron.status.engine': 'Engine Status',
  'cron.status.enabled': 'Enabled',
  'cron.status.disabled': 'Disabled',
  'cron.status.totalJobs': 'Total Jobs',
  'cron.status.nextWake': 'Next Wake',
  'cron.status.in': 'in {time}',
  'cron.searchPlaceholder': 'Search jobs...',
  'cron.refresh': 'Refresh',
  'cron.newJob': 'New Job',
  'cron.loadError.title': 'Failed to load cron jobs',
  'cron.loadError.description': 'An error occurred while retrieving the cron jobs from the server.',
  'cron.retry': 'Retry',
  'cron.empty.title': 'No cron jobs found.',
  'cron.empty.description': 'Create your first cron job to automate tasks.',
  'cron.empty.search': 'No matching jobs found.',
  'cron.card.untitled': 'Untitled Job',
  'cron.card.schedule.cron': 'Cron: {expr}',
  'cron.card.schedule.every': 'Every {seconds}s',
  'cron.card.schedule.at': 'At {time}',
  'cron.card.schedule.unknown': 'Unknown',
  'cron.card.status.unknown': 'Unknown',
  'cron.card.action.edit': 'Edit Job',
  'cron.card.action.duplicate': 'Duplicate',
  'cron.card.action.delete': 'Delete',
  'cron.card.target': 'Target',
  'cron.card.lastRun': 'Last Run',
  'cron.card.lastRun.never': 'Never',
  'cron.card.nextRun': 'Next Run',
  'cron.form.title.create': 'Create Cron Job',
  'cron.form.title.edit': 'Edit Cron Job',
  'cron.form.description': 'Configure schedule and task payload for this automated agent action',
  'cron.form.tabs.basics': 'Basics & Schedule',
  'cron.form.tabs.execution': 'Execution Target',
  'cron.form.tabs.payload': 'Task Payload',
  'cron.form.name.label': 'Name *',
  'cron.form.name.placeholder': 'e.g. Daily Market Summary',
  'cron.form.desc.label': 'Description',
  'cron.form.desc.placeholder': 'What does this do?',
  'cron.form.enabled': 'Job Enabled',
  'cron.form.schedule.title': 'Schedule Configuration',
  'cron.form.schedule.type': 'Type',
  'cron.form.schedule.type.cron': 'Cron Expression',
  'cron.form.schedule.type.every': 'Interval (Every X ms)',
  'cron.form.schedule.type.at': 'Specific Date/Time',
  'cron.form.schedule.cronExpr': 'Cron Expression',
  'cron.form.schedule.cronExpr.placeholder': '0 8 * * *',
  'cron.form.schedule.everyMs': 'Interval (ms)',
  'cron.form.execution.target': 'Target Session',
  'cron.form.execution.target.main': 'Main (Default Agent)',
  'cron.form.execution.target.isolated': 'Isolated / Background',
  'cron.form.execution.target.current': 'Current UI Session',
  'cron.form.execution.desc': 'Determines which conversation context the background task will interact with.',
  'cron.form.payload.type': 'Payload Type',
  'cron.form.payload.type.agentTurn': 'Agent Turn (Issue Prompt)',
  'cron.form.payload.type.systemEvent': 'System Event (Invisible)',
  'cron.form.payload.text.agentTurn': 'Prompt Text',
  'cron.form.payload.text.systemEvent': 'Event Data',
  'cron.form.payload.placeholder.agentTurn': "e.g. Generate a daily summary of yesterday's alerts...",
  'cron.form.payload.placeholder.systemEvent': 'JSON or plain text...',
  'cron.form.actions.cancel': 'Cancel',
  'cron.form.actions.saving': 'Saving...',
  'cron.form.actions.save': 'Save Job'
}

export const enTranslations: Record<string, string> = {
  ...navigation,
  ...controls,
  ...user,
  ...settingsLanguage,
  ...settingsActions,
  ...settingsCommon,
  ...settingsContentProcessing,
  ...settingsEmbedding,
  ...settingsFiles,
  ...notebooksPage,
  ...notebooksList,
  ...notebooksCard,
  ...notebooksHeader,
  ...notebooksDetail,
  ...notebooksKnowledgeGraph,
  ...notebooksSources,
  ...notebooksNotes,
  ...notebooksChat,
  ...notebooksEditor,
  ...notebookAssociations,
  ...commonCommandPalette,
  ...commonAddButton,
  ...commonTheme,
  ...commonActions,
  ...commonConfirmDialog,
  ...commonErrorBoundary,
  ...commonConnection,
  ...commonModelSelector,
  ...modelSelectorDialog,
  ...commonContextToggle,
  ...commonContextIndicator,
  ...searchPage,
  ...sourcesPage,
  ...auth,
  ...imageGeneratorPage,
  ...podcastsPage,
  ...addSourceDialog,
  ...addExistingSourceDialog,
  ...createNotebookDialog,
  ...collapsibleColumn,
  ...modelsPage,
  ...providerStatus,
  ...providerSettings,
  ...modelTypeSection,
  ...defaultModelsSection,
  ...addModelForm,
  ...embeddingModelChangeDialog,
  ...podcasts,
  ...transformations,
  ...digitalEmployeesPage,
  ...marketplacePage,
  ...workflowsPage,
  ...advancedPage,
  ...sourceCard,
  ...sourceDetail,
  ...streamingResponse,
  ...advancedModelsDialog,
  ...saveToNotebooksDialog,
  ...modelsToast,
  ...xhsqunToast,
  ...dykolToast,
  ...xhsqunPrivateToast,
  ...emailTemplateToast,
  ...emailRenewToast,
  ...gnkeyToast,
  ...emailCustomerToast,
  ...emailTaskToast,
  ...workflowsToast,
  ...gzhkolMonitorToast,
  ...gzhkolResourceToast,
  ...dykolTask,
  ...notebooksToast,
  ...emailTaskPage,
  ...notesToast,
  ...podcastsToast,
  ...searchToast,
  ...settingsToast,
  ...sourcesToast,
  ...transformationsToast,
  ...versionCheckToast,
  ...chatToast,
  ...commonToast,
  ...skillsPage,
  ...cronPage,
}
